<template>
  <div>
    <b-row>
      <b-col
          md="6"
          xl="6"
          style="margin-top: -1em"
      >
        <div class="p-1" style="background-color: #292f46;border-radius: 0.5em">
          <b-tabs pills>
            <b-tab fill title="Abholadresse" active>
              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group label="Kennnummer" label-size="sm">
                    <b-input-group>
                      <b-form-input
                          v-model="vData.PickUpPassengerNumber"
                          @keyup.enter="SelectPickupAddressById($event, 1)"
                          ref="PickUpPassengerNumber"
                          size="sm"
                          tabindex="1"
                          @blur="SelectPickupAddressById($event, 2)"
                      />
                      <template #append>
                        <b-button
                            :variant="GetPickupNumberState()"
                            @click="SaveAddress('pickup')"
                            size="sm"
                        >
                          <feather-icon
                              size="14"
                              icon="SaveIcon"
                              class="mr-50"
                          />
                        </b-button>
                      </template>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col
                    md="8"
                    xl="8"
                >
                  <b-form-group
                      label="Name, Vorname"
                      label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                          v-model="vData.PickUpAddressContact.Name"
                          @input="SearchPickupAddressByName"
                          id="PickupAddressData-popoverShow"
                          @blur.stop="ClosePopover()"
                          size="sm"
                          tabindex="2"
                      />
                      <template #append>
                        <b-button
                            variant="danger"
                            @click="ResetAddress('pickup')"
                            size="sm"
                            v-ripple.400="'rgba(241,6,64,0.15)'"
                            v-b-tooltip.hover.v-info
                            title="Felder leeren"
                        >
                          <feather-icon
                              size="14"
                              icon="Trash2Icon"
                              class="mr-50"
                          />
                        </b-button>
                      </template>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Postleitzahl"
                      label-for="ZipCode"
                      label-size="sm"
                  >
                    <b-form-input
                        id="ZipCode"
                        v-model="vData.PickUpAddress.ZipCode"
                        size="sm"
                        tabindex="3"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ort"
                      label-for="Location"
                      label-size="sm"
                  >
                    <b-form-input
                        id="Location"
                        v-model="vData.PickUpAddress.Location"
                        size="sm"
                        tabindex="4"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ortsteil"
                      label-for="District"
                      label-size="sm"
                  >
                    <b-form-input
                        id="District"
                        v-model="vData.PickUpAddress.District"
                        size="sm"
                        tabindex="5"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="12"
                    xl="12"
                >
                  <b-form-group
                      label="Adresse"
                      label-size="sm"
                  >
                    <b-form-input
                        @keyup="OpenPopover('pickupStreet')"
                        id="PickupAddressData-Street-popoverShow"
                        @blur.stop="ClosePopoverStreet()"
                        v-model="vData.PickUpAddress.Street"
                        ref="PickupAddressStreet"
                        size="sm"
                        tabindex="6"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      v-show="vData.PickUpAddress.Street != 'Terminalring 11'"
                      label="Telefon"
                      label-for="phone"
                      label-size="sm"
                  >
                    <cleave
                        v-model="vData.PickUpAddressContact.Phone"
                        id="phone"
                        class="form-control form-control-sm"
                        :options="options.number"
                        size="sm"
                        tabindex="7"
                    />

                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      v-show="vData.PickUpAddress.Street != 'Terminalring 11'"
                      label="Handy"
                      label-for="PassengerPhone2"
                      label-size="sm"
                  >
                    <cleave
                        id="PassengerPhone2"
                        v-model="vData.PickUpAddressContact.Phone2"
                        class="form-control form-control-sm"
                        :options="options.number"
                        size="sm"
                        tabindex="8"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      v-show="vData.PickUpAddress.Street != 'Terminalring 11'"
                      label="E-Mail"
                      label-for="PassengerEmail"
                      label-size="sm"
                  >
                    <b-form-input
                        class="index_passengeremail"
                        id="PassengerEmail"
                        v-model="vData.PickUpAddressContact.Email"
                        size="sm"
                        tabindex="9"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab fill title="Zwischenhalt" v-for="(stop, index) in vData.Stopovers">
              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                </b-col>
                <b-col
                    md="8"
                    xl="8"
                >
                  <b-form-group
                      label="Name, Vorname"
                      label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                          v-model="stop.Contact.Name"
                          @input="SearchPickupAddressByName"
                          id="PickupAddressData-popoverShow"
                          @blur.stop="ClosePopover()"
                          size="sm"
                          tabindex="2"
                      />
                      <template #append>
                        <b-button
                            variant="danger"
                            @click="ResetAddress('pickup')"
                            size="sm"
                            v-ripple.400="'rgba(241,6,64,0.15)'"
                            v-b-tooltip.hover.v-info
                            title="Felder leeren"
                        >
                          <feather-icon
                              size="14"
                              icon="Trash2Icon"
                              class="mr-50"
                          />
                        </b-button>
                      </template>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Postleitzahl"
                      label-for="ZipCode"
                      label-size="sm"
                  >
                    <b-form-input
                        id="ZipCode"
                        v-model="stop.Address.ZipCode"
                        size="sm"
                        tabindex="3"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ort"
                      label-for="Location"
                      label-size="sm"
                  >
                    <b-form-input
                        id="Location"
                        v-model="stop.Address.Location"
                        size="sm"
                        tabindex="4"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ortsteil"
                      label-for="District"
                      label-size="sm"
                  >
                    <b-form-input
                        id="District"
                        v-model="stop.Address.District"
                        size="sm"
                        tabindex="5"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="12"
                    xl="12"
                >
                  <b-form-group
                      label="Adresse"
                      label-size="sm"
                  >
                    <b-form-input
                        @keyup="OpenPopover('pickupStreet')"
                        id="PickupAddressData-Street-popoverShow"
                        @blur.stop="ClosePopoverStreet()"
                        v-model="stop.Address.Street"
                        ref="PickupAddressStreet"
                        size="sm"
                        tabindex="6"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Telefon"
                      label-for="phone"
                      label-size="sm"
                  >
                    <cleave
                        v-model="stop.Contact.Phone"
                        id="phone"
                        class="form-control form-control-sm"
                        :options="options.number"
                        size="sm"
                        tabindex="7"
                    />

                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Handy"
                      label-for="PassengerPhone2"
                      label-size="sm"
                  >
                    <cleave
                        id="PassengerPhone2"
                        v-model="stop.Contact.Phone2"
                        class="form-control form-control-sm"
                        :options="options.number"
                        size="sm"
                        tabindex="8"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="E-Mail"
                      label-for="PassengerEmail"
                      label-size="sm"
                  >
                    <b-form-input
                        class="index_passengeremail"
                        id="PassengerEmail"
                        v-model="stop.Contact.Email"
                        size="sm"
                        tabindex="9"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Map">
              <GmapMap
                  :center="Maps.Pickup.Center"
                  :zoom="10"
                  style="width:100%;  height: 300px;"
              >
                <GmapMarker
                    :key="index"
                    v-for="(m, index) in Maps.Pickup.markers"
                    :icon="m.icon"
                    :position="m.position"
                    @click="Maps.Pickup.Center=m.position"
                />
              </GmapMap>
            </b-tab>

          </b-tabs>
        </div>
        <div id="pickupAddress">
        </div>
        <div id="pickupInfo">
        </div>
      </b-col>
      <b-col
          md="6"
          xl="6"
          style="margin-top: -1em"
      >

        <div class="p-1 " style="background-color: #292f46;border-radius: 0.5em">
          <b-tabs pills>
            <b-tab fill title="Zieladresse" active>
              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Kennnummer"
                      label-size="sm"
                  >
                    <b-input-group>
                      <b-form-input
                          v-model="vData.DestinationPassengerNumber"
                          @keyup.enter="SelectDestinationAddressById($event, 2)"
                          @blur="SelectDestinationAddressById($event, 2)"
                          ref="DestinationPassengerNumber"
                          size="sm"
                          tabindex="10"
                      />

                      <template #append>
                        <b-button
                            :variant="GetDestinationNumberState()"
                            @click="SaveAddress('destination')"
                            size="sm"
                        >
                          <feather-icon
                              size="14"
                              icon="SaveIcon"
                              class="mr-50"
                          />
                        </b-button>
                      </template>

                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col
                    md="8"
                    xl="8"
                >

                  <b-form-group
                      label="Name, Vorname"
                      label-size="sm"
                  >
                    <b-input-group>
                    <b-form-input
                        v-model="vData.DestinationAddressContact.Name"
                        @input="SearchDestinationAddressByName"
                        id="DestinationAddressData-popoverShow"
                        @blur.stop="ClosePopover()"
                        size="sm"
                        tabindex="11"
                    />

                      <template #append>
                        <b-button
                            variant="danger"
                            @click="ResetAddress('destination')"
                            size="sm"
                            v-ripple.400="'rgba(241,6,64,0.15)'"
                            v-b-tooltip.hover.v-info
                            title="Felder leeren"
                        >
                          <feather-icon
                              size="14"
                              icon="Trash2Icon"
                              class="mr-50"
                          />
                        </b-button>
                      </template>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Postleitzahl"
                      label-for="ZipCode"
                      label-size="sm"
                  >
                    <b-form-input
                        id="ZipCode"
                        v-model="vData.DestinationAddress.ZipCode"
                        size="sm"
                        tabindex="12"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ort"
                      label-for="Location"
                      label-size="sm"
                  >
                    <b-form-input
                        id="Location"
                        v-model="vData.DestinationAddress.Location"
                        size="sm"
                        tabindex="13"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      label="Ortsteil"
                      label-for="District"
                      label-size="sm"
                  >
                    <b-form-input
                        id="District"
                        v-model="vData.DestinationAddress.District"
                        size="sm"
                        tabindex="14"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="12"
                    xl="12"
                >
                  <b-form-group
                      label="Adresse"
                      label-size="sm"
                  >
                    <b-form-input
                        @keyup="OpenPopover('destinationStreet')"
                        id="DestinationAddressData-Street-popoverShow"
                        @blur.stop="ClosePopoverStreet()"
                        v-model="vData.DestinationAddress.Street"
                        ref="DestinationAddressStreet"
                        size="sm"
                        tabindex="15"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      v-show="vData.DestinationAddress.Street != 'Terminalring 11'"
                      label="Telefon"
                      label-for="DestinationPhone2"
                      label-size="sm"
                  >
                    <cleave
                        id="DestinationPhone2"
                        v-model="vData.DestinationAddressContact.Phone"
                        class="form-control form-control-sm"
                        :options="options.number"
                        size="sm"
                        tabindex="16"
                    />

                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                      v-show="vData.DestinationAddress.Street != 'Terminalring 11'"
                      label="Handy"
                      label-for="PassengerPhone2"
                      label-size="sm"
                  >
                    <cleave
                        id="PassengerPhone2"
                        v-model="vData.DestinationAddressContact.Phone2"
                        class="form-control form-control-sm"
                        :options="options.number"
                        size="sm"
                        tabindex="17"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    xl="4"
                >
                  <b-form-group
                    v-show="vData.DestinationAddress.Street != 'Terminalring 11'"
                      label="E-Mail"
                      label-for="PassengerEmail"
                    label-size="sm"
                  >
                    <b-form-input
                        class="index_passengeremail"
                        id="PassengerEmail"
                        v-model="vData.DestinationAddressContact.Email"
                        size="sm"
                        tabindex="18"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Information">
              <h4>Entfernung: {{ new Intl.NumberFormat().format(this.vData.TripRoute.TripDistanceMeter) }}km<br></h4>
              <h4>Fahrzeit (Mit Fahrgast): ca. {{ parseInt(this.vData.TripRoute.TripDuration / 60) }} Minuten ({{ (parseInt(this.vData.TripRoute.TripDuration / 60) / 60).toFixed(2) }}h)</h4>
              <h4>Fahrzeit: ca. {{ parseInt(this.vData.TripRoute.TripFullDuration / 60) }} Minuten ({{ (parseInt(this.vData.TripRoute.TripFullDuration / 60) / 60).toFixed(2) }}h)</h4>
              <h4>Taxipreis: ca. {{ this.$options.filters.currency(this.vData.Taxipreis) }}</h4>
              <hr v-if="this.vData.RideType == 1">
              <h4 v-if="this.vData.RideType == 1">Krankenkassenpreis: ca. {{ this.$options.filters.currency(this.vData.MedicalPrice) }}</h4>
              <h4>Google-Maps: <a :href="GetGoogleMaps()">Öffnen</a> </h4>

            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col
          md="6"
          xl="6"
          style="margin-top: 1em"
      >
        <b-card-code>
          <b-row
              style="margin-top: -2em; margin-bottom: 2em"
          >
            <b-col
                md="4"
                xl="4"
            >
              <b-tabs
                  align="left"
                  v-show="vData.Vid == 0 && (!IsCrewTrip)"
              >
                <b-tab
                    title="Hinfahrt"
                    :active="TripType == 0"
                    @click="TripType = 0"
                />
                <b-tab
                    title="Rückfahrt"
                    :active="TripType == 1"
                    @click="TripType = 1"
                />
              </b-tabs>
            </b-col>
            <b-col
                md="8"
                xl="8"
            >

              <b-tabs
                  align="right"
                  v-show="!IsCrewTrip"
              >
                <b-tab
                    title="Flughafentransfer"
                    :active="vData.RideType == 0"
                    @click="ChangeRideType(0)"
                />
                <b-tab
                    title="Krankenfahrt"
                    :active="vData.RideType == 1"
                    @click="ChangeRideType(1)"
                />
                <b-tab
                    title="Mietwagen"
                    :active="vData.RideType == 2"
                    @click="ChangeRideType(2)"
                />
              </b-tabs>

              <b-tabs
                  align="right"
                  v-show="IsCrewTrip"
              >
                <b-tab
                    title="Crew"
                    :active="vData.RideType == 0"
                    @click="ChangeRideType(0)"
                />
              </b-tabs>

            </b-col>
          </b-row>
          <div v-show="TripType == 0">
            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Reisetag"
                    label-for="Reisetag"
                    prepend="@"
                    class="input-group-merge"
                    size="sm"
                >
                  <b-input-group
                      :prepend="TravelDayName"
                      class="input-group-merge"
                      size="sm"
                  >
                    <cleave
                        id="date"
                        v-model="vData.TravelDay"
                        class="form-control form-control-sm"
                        :raw="false"
                        :options="options.date"
                        placeholder="DD.MM.YY"
                        ref="TravelDay"
                        @keyup.enter.native="NextInput('TravelDay')"
                        @keyup.native="NumberOnlyAndAddDay($event)"
                        size="sm"
                        tabindex="19"
                    />
                    <template #append>
                      <b-form-datepicker
                          :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                          button-only
                          :start-weekday="1"
                          locale="de-DE"
                          color="danger"
                          size="sm"
                          @context="onDateFromContext"
                      />
                    </template>

                  </b-input-group>
                </b-form-group>
              </b-col>


              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Erw."
                    label-for="Passengers"
                >

                  <cleave
                      id="Passengers"
                      v-model="vData.Passengers"
                      class="form-control form-control-sm"
                      ref="Passengers"
                      @keyup.native.enter="NextInput('Passengers')"
                      size="sm"
                      :options="options.number"
                      tabindex="20"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Ki."
                    label-for="PassengersChildren"
                >
                  <cleave
                      id="PassengersChildren"
                      v-model="vData.PassengersChildren"
                      class="form-control form-control-sm"
                      ref="PassengersChildren"
                      @keyup.native.enter="NextInput('PassengersChildren')"
                      size="sm"
                      :options="options.number"
                      tabindex="21"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Zubehör"
                    label-for="Equipment"
                >

                  <b-form-select v-model="vData.Equipment" @change="SelectEquipment"
                                 size="sm"
                                 tabindex="22"
                  >
                    <option
                        v-for="(option, idx) in EquipmentList"
                        :key="idx"
                        :value="option.value.IdentId"
                        :title="option.title || null"
                    >
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-show="vData.RideType == 2">
              <b-col
                  md="8"
                  xl="8"
              >
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Abholzeit"
                    label-for="pickup"
                >
                  <cleave
                      id="pickup"
                      v-model="vData.PickupTime"
                      class="form-control form-control-sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="PickupTime2"
                      @keyup.enter.native="NextInput('PickupTime')"
                      size="sm"
                      tabindex="23"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    :label="options.Time2Label"
                    label-for="pickup"
                >

                  <cleave
                      id="pickup"
                      v-model="vData.Flight.ScheduledTime"
                      class="form-control form-control-sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ScheduledTime2"
                      @keyup.enter.native="NextInput('ScheduledTime')"
                      tabindex="32"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-show="vData.RideType == 1">
              <b-col
                  md="4"
                  xl="4"
              >

                <b-form-group
                    label="Transportschein"
                    label-for="transportTicket
"
                >
                  <b-form-select v-model="vData.MedicalTrip.TransportTicket" @change="SelectTransportTicket"
                                 ref="TransportTicket"
                                 size="sm"
                                 tabindex="24"
                  >
                    <option
                        v-for="(option, idx) in TransportTicketList"
                        :key="idx"
                        :value="option.value"
                        :title="option.title"
                    >
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Zuzahlung"
                    label-for="priceMedical"
                >
                  <b-form-select v-model="vData.MedicalTrip.AdditionalPayment" @change="SelectAdditionalPayment"
                                 ref="AdditionalPayment"
                                 size="sm"

                                 tabindex="25"
                  >
                    <option
                        v-for="(option, idx) in AdditionalPaymentList"
                        :key="idx"
                        :value="option.value"
                        :title="option.title"
                    >
                      {{ option.text }}
                    </option>
                  </b-form-select>

                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Abholzeit"
                    label-for="pickup"
                >
                  <cleave
                      id="pickup"
                      v-model="vData.PickupTime"
                      class="form-control form-control-sm"
                      size="sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="PickupTime1"
                      @keyup.enter.native="NextInput('PickupTime')"
                      tabindex="26"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    :label="options.Time2Label"
                    label-for="pickup"
                >
                  <cleave
                      id="pickup"
                      v-model="vData.MedicalTrip.AppointmentTime"
                      class="form-control form-control-sm"
                      size="sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ScheduledTime1"
                      @keyup.enter.native="SelectInput('Description')"
                      tabindex="27"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-show="vData.RideType == 0">
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Flugnummer"
                    label-for="iata"
                >
                  <b-input-group>
                    <b-form-input
                        id="iata"
                        v-model="vData.Flight.Iata"
                        class="form-control form-control-sm"
                        placeholder="DE0000"
                        @keyup.enter.native="GetIataData('Iata')"
                        @keyup="vData.Flight.Iata = vData.Flight.Iata.toUpperCase()"
                        ref="Iata"
                        tabindex="28"
                    />
                    <template #append>
                      <b-button
                          variant="success"
                          @click="SaveFlight(1)"
                          size="sm"
                      >
                        <feather-icon
                            size="14"
                            icon="SaveIcon"
                            class="mr-50"
                        />
                      </b-button>
                    </template>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Start"
                    label-for="departure"
                    :description="vData.Flight.DepartureName"
                >


                  <b-form-input
                    id="departure"
                    v-model="vData.Flight.Departure"
                    @keyup="vData.Flight.Departure = vData.Flight.Departure.toUpperCase()"
                    class="form-control form-control-sm"
                    size="sm"
                    placeholder=""
                    ref="Departure"
                    @keyup.native.enter="NextInput('Departure')"
                    tabindex="29"
                  />

                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Ziel"
                    label-for="arrivals"
                    :description="vData.Flight.ArrivalsName"
                >
                  <b-form-input
                    id="arrivals"
                    v-model="vData.Flight.Arrivals"
                    @keyup="vData.Flight.Arrivals = vData.Flight.Arrivals.toUpperCase()"
                    class="form-control form-control-sm"
                    placeholder=""
                    size="sm"
                    ref="Arrivals"
                    @keyup.native.enter="NextInput('Arrivals')"
                    tabindex="30"
                  />

                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Abholzeit"
                    label-for="pickup"
                >
                  <cleave
                      id="pickup"
                      v-model="vData.PickupTime"
                      class="form-control  form-control-sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="PickupTime0"
                      @keyup.enter.native="NextInput('PickupTime')"
                      tabindex="31"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    :label="options.Time2Label"
                    label-for="pickup"
                    :description="FormatTime(vData.Flight.ScheduledTimeCorrected) + ' Uhr'"
                >

                  <cleave
                      id="pickup"
                      v-model="vData.Flight.ScheduledTime"
                      class="form-control form-control-sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ScheduledTime0"
                      @keyup.enter.native="NextInput('ScheduledTime')"
                      tabindex="32"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Fahrerinfo (Zeile kurz)"
                    label-for="Description"
                >

                  <b-form-input
                      id="Description"
                      ref="Description"
                      v-model="vData.Description1"
                      class="form-control form-control-sm"
                      size="sm"
                      placeholder=""
                      @keyup.enter="NextInput('Description')"
                      tabindex="33"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="8"
                  xl="8"
              >
                <b-form-group
                    label="Fahrerinfo (Zeile Lang)"
                    label-for="Description2"
                >

                  <b-form-input
                      id="Description2"
                      ref="Description2"
                      v-model="vData.Description2"
                      class="form-control form-control-sm"
                      size="sm"
                      placeholder=""
                      @keyup.enter="NextInput('Description2')"
                      tabindex="34"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="12"
                  xl="12"
              >
                <b-form-group
                    label="Text für Buchungsbestätigung"
                    label-for="DescriptionPdf"
                >

                  <b-form-input
                      id="DescriptionPdf"
                      ref="DescriptionPdf"
                      v-model="vData.DescriptionPdf"
                      class="form-control form-control-sm"
                      size="sm"
                      placeholder=""
                      @keyup.enter="NextInput('DescriptionPdf')"
                      tabindex="35"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <!--          Rückfahrt-->
          <div v-show="TripType == 1">
            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Reisetag"
                    label-for="Reisetag"
                    prepend="@"
                    class="input-group-merge"
                    size="sm"
                >
                  <b-input-group
                      :prepend="ReturnTravelDayName"
                      class="input-group-merge"
                      size="sm"
                  >

                    <cleave
                        id="date"
                        v-model="returnTripData.TravelDay"
                        class="form-control form-control-sm"
                        :raw="false"
                        :options="options.date"
                        placeholder="DD.MM.YY"
                        ref="ReturnTravelDay"
                        @keyup.enter.native="NextInput('ReturnTravelDay')"
                        @keyup.esc.native="NextInput('ReturnTravelDay', 'cancel')"
                        @keyup.native="NumberOnlyAndAddDay2($event)"
                        size="sm"
                    />
                    <template #append>
                      <b-form-datepicker
                          :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                          button-only
                          :start-weekday="1"
                          locale="de-DE"
                          color="danger"
                          size="sm"
                          @context="onDateFromReturnContext"
                      />
                    </template>

                  </b-input-group>
                </b-form-group>
              </b-col>


              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Erw."
                    label-for="Passengers"
                >

                  <cleave
                      id="Passengers"
                      v-model="returnTripData.Passengers"
                      class="form-control form-control-sm"
                      ref="ReturnPassengers"
                      @keyup.native.enter="NextInput('ReturnPassengers')"
                      size="sm"
                      :options="options.number"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Ki."
                    label-for="PassengersChildren"
                >
                  <cleave
                      id="ReturnPassengersChildren"
                      v-model="returnTripData.PassengersChildren"
                      class="form-control form-control-sm"
                      ref="ReturnPassengersChildren"
                      @keyup.native.enter="NextInput('ReturnPassengersChildren')"
                      size="sm"
                      :options="options.number"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Zubehör"
                    label-for="Equipment"
                >

                  <b-form-select v-model="returnTripData.Equipment" @change="SelectEquipment"
                                 size="sm"
                  >
                    <option
                        v-for="(option, idx) in EquipmentList"
                        :key="idx"
                        :value="option.value.IdentId"
                        :title="option.title || null"
                    >
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-show="vData.RideType == 2">
              <b-col
                  md="8"
                  xl="8"
              >
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Abholzeit"
                    label-for="pickup"
                >

                  <cleave
                      id="pickup"
                      v-model="returnTripData.PickupTime"
                      class="form-control form-control-sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ReturnPickupTime2"
                      @keyup.enter.native="NextInput('ReturnPickupTime')"
                      size="sm"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    :label="options.Time2Label"
                    label-for="pickup"
                >
                  <cleave
                      id="pickup"
                      v-model="returnTripData.Flight.ScheduledTime"
                      class="form-control form-control-sm"
                      size="sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ReturnScheduledTime2"
                      @keyup.enter.native="SelectInput('ReturnDescription')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-show="vData.RideType == 1">
              <b-col
                  md="4"
                  xl="4"
              >

                <b-form-group
                    label="Transportschein"
                    label-for="transportTicket
"
                >
                  <b-form-select v-model="returnTripData.MedicalTrip.TransportTicket" @change="SelectTransportTicket"
                                 ref="ReturnTransportTicket"
                                 size="sm"
                  >
                    <option
                        v-for="(option, idx) in TransportTicketList"
                        :key="idx"
                        :value="option.value"
                        :title="option.title"
                    >
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Zuzahlung"
                    label-for="priceMedical"
                >
                  <b-form-select v-model="returnTripData.MedicalTrip.AdditionalPayment" @change="SelectAdditionalPayment"
                                 ref="ReturnAdditionalPayment"
                                 size="sm"
                  >
                    <option
                        v-for="(option, idx) in AdditionalPaymentList"
                        :key="idx"
                        :value="option.value"
                        :title="option.title"
                    >
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Abholzeit"
                    label-for="pickup"
                >
                  <cleave
                      id="pickup"
                      v-model="returnTripData.PickupTime"
                      class="form-control form-control-sm"
                      size="sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ReturnPickupTime1"
                      @keyup.enter.native="NextInput('ReturnPickupTime')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    :label="options.Time2Label"
                    label-for="pickup"
                >
                  <cleave
                      id="pickup"
                      v-model="returnTripData.MedicalTrip.AppointmentTime"
                      class="form-control form-control-sm"
                      size="sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ReturnScheduledTime1"
                      @keyup.enter.native="SelectInput('ReturnDescription')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-show="vData.RideType == 0">
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Flugnummer"
                    label-for="iata"
                >
                  <b-input-group>
                    <b-form-input
                        id="iata"
                        v-model="returnTripData.Flight.Iata"
                        class="form-control form-control-sm"
                        placeholder="DE0000"
                        @keyup.enter.native="GetIataData('ReturnIata')"
                        @keyup="returnTripData.Flight.Iata = returnTripData.Flight.Iata.toUpperCase()"
                        ref="ReturnIata"
                    />

                    <template #append>
                      <b-button
                          variant="success"
                          @click="SaveFlight(2)"
                          size="sm"
                      >
                        <feather-icon
                            size="14"
                            icon="SaveIcon"
                            class="mr-50"
                        />
                      </b-button>
                    </template>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Start"
                    label-for="departure"
                >

                  <b-form-input
                    id="departure"
                    v-model="returnTripData.Flight.Departure"
                    @keyup="returnTripData.Flight.Departure = returnTripData.Flight.Departure.toUpperCase()"
                    class="form-control form-control-sm"
                    size="sm"
                    placeholder=""
                    ref="ReturnDeparture"
                    @keyup.native.enter="NextInput('ReturnDeparture')"
                  />

                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Ziel"
                    label-for="arrivals"
                >

                  <b-form-input
                    id="arrivals"
                    v-model="returnTripData.Flight.Arrivals"
                    @keyup="returnTripData.Flight.Arrivals = returnTripData.Flight.Arrivals.toUpperCase()"
                    class="form-control form-control-sm"
                    placeholder=""
                    size="sm"
                    ref="ReturnArrivals"
                    @keyup.native.enter="NextInput('ReturnArrivals')"
                  />

                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Abholzeit"
                    label-for="ReturnPickupTime0"
                >
                  <cleave
                      id="ReturnPickupTime0"
                      v-model="returnTripData.PickupTime"
                      class="form-control  form-control-sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ReturnPickupTime0"
                      @keyup.enter.native="NextInput('ReturnPickupTime')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    :label="options.Time2Label"
                    label-for="ReturnScheduledTime0"
                >
                  <cleave
                      id="ReturnScheduledTime0"
                      v-model="returnTripData.Flight.ScheduledTime"
                      class="form-control form-control-sm"
                      :raw="false"
                      :options="options.time"
                      placeholder="hh:mm"
                      ref="ReturnScheduledTime0"
                      @keyup.enter.native="SelectInput('ReturnDescription')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Fahrerinfo (Zeile kurz)"
                    label-for="Description"
                >

                  <b-form-input
                      id="Description"
                      ref="ReturnDescription"
                      v-model="returnTripData.Description1"
                      class="form-control form-control-sm"
                      size="sm"
                      placeholder=""
                      @keyup.enter="SelectInput('ReturnDescription2')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="8"
                  xl="8"
              >
                <b-form-group
                    label="Fahrerinfo (Zeile Lang)"
                    label-for="Description2"
                >

                  <b-form-input
                      id="Description2"
                      ref="ReturnDescription2"
                      v-model="returnTripData.Description2"
                      class="form-control form-control-sm"
                      size="sm"
                      placeholder=""
                      @keyup.enter="SelectInput('ReturnDescriptionPdf')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="12"
                  xl="12"
              >
                <b-form-group
                    label="Text für Buchungsbestätigung"
                    label-for="DescriptionPdf"
                >

                  <b-form-input
                      id="DescriptionPdf"
                      ref="ReturnDescriptionPdf"
                      v-model="returnTripData.DescriptionPdf"
                      class="form-control form-control-sm"
                      size="sm"
                      placeholder=""
                      @keyup.enter="NextInput('ReturnDescriptionPdf')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>

        </b-card-code>

      </b-col>
      <b-col
          md="6"
          xl="6"
          style="margin-top: 1em"
      >

        <b-card-code title="Zahlungsinfomation">
          <b-row>

            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="Rechnungskunde"
                  label-for="CustomerNumber"
              >
                <b-form-input
                    v-model="Customer.Number"
                    class="form-control form-control-sm"
                    size="sm"
                    ref="CustomerNumber"
                    @keyup.native.enter="LoadCustomer();"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="9"
                xl="9"
            >
              <b-form-group
                  label="Name"
                  label-for="CustomerName"
              >
                <b-form-input
                    v-model="Customer.Name"
                    class="form-control form-control-sm"
                    size="sm"
                    id="Customer-popoverShow"
                    @input="SearchCustomerByName"
                    @blur.stop="ClosePopoverCustomerSearch()"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="Fahrpreis"
                  label-for="price"
                  v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                  v-b-tooltip.hover.v-info
                  :title="zoneName"
                  variant="outline-info"
              >
                <div>
                  <euro-field ref="EuroFieldPrice" v-show="!loading.price" @keyup.native="setLoadingBar()"/>
                </div>
                <div
                    class="d-flex flex-wrap ml-5"
                >
                  <b-spinner
                      v-show="loading.price"
                      variant="warning"
                      class="mr-1"
                      type="grow"
                  />
                </div>

              </b-form-group>
            </b-col>

            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  :label="vData.RideType == 1 ? 'Zuzahlung (€)' : 'Extrapreis'"
                  label-for="price"
              >
                <euro-field ref="EuroFieldExtraPrice"/>
              </b-form-group>
            </b-col>
            <b-col
                md="3"
                xl="3"
            >
              <b-form-group
                  label="MwSt."
                  label-for="mwst"
              >

                <b-form-input
                    v-model="VatRateLabel"
                    class="form-control form-control-sm"
                    size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
                xl="3"
                v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                v-b-tooltip.hover.v-info
                :title="GetPaymentName(vData.PaymentMethod)"
                variant="outline-info"
            >
              <b-form-group
                  label="Rechnungsbetrag"
                  label-for="Fahrpreis"
              >

                <b-form-input
                    v-model="EndSum"
                    class="form-control form-control-sm"
                    size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row
            v-show="vData.RideType == 1">
            <b-col
              md="5"
              xl="5"
            >
              <b-form-group
                label="DMRZ Id"
                label-for="Fahrpreis"
              >

                <b-form-input
                  v-model="vData.MedicalTrip.DmrzId"
                  class="form-control form-control-sm"
                  size="sm"
                />
              </b-form-group>
            </b-col>

            <b-col
              md="5"
              xl="5"
            >
              <b-form-group
                label="Zahlung von Krankenkasse"
                label-for="Fahrpreis"
              >
                <euro-field ref="MedicalTripPrice"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
                md="11"
                xl="11"
            >
              <b-form-group
                  label="Rechnungstext"
                  label-for="price"
              >

                <b-form-input
                    v-model="vData.DescriptionInvoice"
                    ref="DescriptionInvoice"
                    @keyup.enter.native="NextInput('DescriptionInvoice')"
                    class="form-control form-control-sm"
                    size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="1"
                xl="1"
            >
              <b-form-input style="width: 1px; opacity: 0"
                            ref="LASTINPUT"
                            @blur="hasErrors = true"
                            @keyup.enter.native="SelectInput('LAST')"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col
              md="8"
              xl="8">
              <b-badge
                v-if="ConnectedVoucherData != null"
                v-show="ConnectedVoucherData.Vid != null"
                variant="light-success"
                @click="OpenVoucher(ConnectedVoucherData.Vid)"
                class="cursor-pointer"
              >
                {{ ConnectedVoucherData.Vid != null ? ConnectedVoucherData.TravelName : ''}} : [{{ ConnectedVoucherData.Vid }}] {{ ConnectedVoucherData.TravelWeekDay }}, {{ ConnectedVoucherData.TravelDay }} - {{ ConnectedVoucherData.PickupTime }}
              </b-badge>
            </b-col>
            <b-col
              md="4"
              xl="4">
              <b-row v-for="d in Drivers">
                <b-badge
                    class="mb-1 mr-2"
                    v-bind:style="{color: d.Color2, background: d.Color1, width: '100%'}"
                >{{ d.DriverShortName }}
                </b-badge>
              </b-row>
            </b-col>
            <b-col
                md="5"
                xl="5"
                style="margin-top: 2.3em"
            >
              <b-button
                  v-show="!GetBlocked()"
                  class="col-12"
                  :variant="hasErrors ? 'warning' : 'success'"
                  @click="SaveCheck()"
                  v-model="SaveButton"
              >
                <span v-show="!loading.base"> {{ returnTrip ? 'Weiter zur Rückfahrt' : 'Speichern' }}  </span>
                <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
                <div
                    v-show="loading.base"
                    class="spinner-border spinner-border-sm"
                    role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </b-button>

              <b-button
                  v-show="GetBlocked()"
                  class="col-12"
                  variant="danger"
                  v-model="SaveButton"
                  @click="RouterBack()"
              >
                <span v-show="!loading.base">{{ this.vData.Canceled != null ? 'Voucher ist stoniert.' : this.vData.BillNumber != '' ? 'Voucher ist bereits in Rechnung (' + this.vData.BillNumber + ') gestellt.' : 'Voucher kann nicht bearbeitet werden.' }}</span>
                <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->

                <div
                    v-show="loading.base"
                    class="spinner-border spinner-border-sm"
                    role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </b-button>


              <b-badge
                  v-show="vData.BillNumber != null && vData.BillNumber != ''"
                  class="mt-2" style="color: #e8e8e8; background: #670062; cursor: pointer;"
                  @click="openInNewTab('https://my.sevdesk.de/#/fi/edit/type/RE/id/'+vData.BillNumber)"
              >
                Rechnung: {{ this.vData.BillNumber }}
              </b-badge>
              <b-badge
                  v-show="vData.SevDeskCreditNoteId != null && vData.SevDeskCreditNoteId != ''"
                  class="ml-1 mt-2" style="color: #e8e8e8; background: #007b8d; cursor: pointer;"
                  @click="openInNewTab('https://my.sevdesk.de/#/cn/edit/type/CN/id/'+vData.SevDeskCreditNoteId)"
              >
                Gutschrift: {{ this.vData.SevDeskCreditNoteId }}
              </b-badge>
            </b-col>
            <b-col
                md="2"
                xl="2"
                style="margin-top: 2.3em"
            >

              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-info"
                  @click="OpenDispo">
                Dispo öffnen
              </b-button>
            </b-col>
            <b-col
                md="5"
                xl="5"
                style="margin-top: 2.3em"
            >
              <b-dropdown
                  v-show="vData.Vid > 0"
                  class="btn-block"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="info"
                  right
                  :text="('Voucher: ' + this.vData.Vid)"
              >

                <b-dropdown-item
                    variant="danger"
                    @click="Cancel"
                    v-show="vData.Canceled == null"
                >Stornieren
                </b-dropdown-item>
                <b-dropdown-item
                    variant="danger"
                    @click="UndoCancel"
                    v-show="vData.Canceled != null"
                >Entstornieren
                </b-dropdown-item>
                <b-dropdown-divider/>
                <b-dropdown-item
                    variant="success"
                    @click="ConfirmVoucher(vData.Vid)"
                >Bestätigen
                </b-dropdown-item>

                <b-dropdown-divider/>
                <b-dropdown-item
                    v-show="(this.vData.Vid > 0 && this.vData.PaymentMethod == 3)"
                    @click="OpenPdfInvoice"
                >Quittung
                </b-dropdown-item>
                <b-dropdown-item
                    v-show="this.vData.Vid > 0"
                    @click="OpenProvisionalPdf"
                >
                  <div
                      v-show="loading.openPdf"
                      class="spinner-border spinner-border-sm"
                      role="status"
                  >
                  </div>
                  <div
                      v-show="!loading.openPdf"
                  >
                    Vorl. Buchungsbest.
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                    v-show="this.vData.Vid > 0"
                    @click="OpenPdf"
                >
                  <div
                      v-show="loading.openPdf"
                      class="spinner-border spinner-border-sm"
                      role="status"
                  >
                  </div>
                  <div
                      v-show="!loading.openPdf"
                  >
                    Buchungsbest.
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                    @click="OpenLogs"
                >Logs
                </b-dropdown-item>
                <b-dropdown-item
                    @click="OpenCopyMenu"
                >Kopieren
                </b-dropdown-item>
                <b-dropdown-divider/>
                <b-dropdown-html>
                  <b-form-group
                      style="padding: 0.5em"
                      label="Sumup Transaktionscode "
                      label-for="SumUpTransactionCode"
                  >
                    <b-input-group>
                      <b-form-input
                          v-model="vData.SumUpTransactionCode"
                          id="SumUpTransactionCode"
                          class="form-control form-control-sm"
                          size="sm"
                          tabindex="7"
                      />

                      <template #append>
                        <b-button
                            variant="success"
                            @click="SaveSumup()"
                            size="sm"
                        >
                          <feather-icon
                              size="14"
                              icon="SaveIcon"
                              class="mr-50"
                          />
                        </b-button>
                      </template>
                    </b-input-group>
                  </b-form-group>
                </b-dropdown-html>

                <b-dropdown-html>
                  <b-form-group
                      style="padding: 0.5em"
                      label="Verbundener Voucher"
                      label-for="connectedVoucher"
                      v-show="vData.ConnectedVoucherId == 0"
                  >
                    <b-input-group>
                      <cleave
                          v-model="NewConnectedVoucherId"
                          id="connectedVoucher"
                          class="form-control form-control-sm"
                          :options="options.number"
                          size="sm"
                          tabindex="7"
                      />

                      <template #append>
                        <b-button
                            variant="success"
                            @click="SaveConnectedVoucher()"
                            size="sm"
                        >
                          <feather-icon
                              size="14"
                              icon="SaveIcon"
                              class="mr-50"
                          />
                        </b-button>
                      </template>
                    </b-input-group>


                  </b-form-group>
                  <b-form-group
                      label="Verbundener Voucher"
                      label-for="connectedVoucher"
                      v-show="vData.ConnectedVoucherId > 0"
                  >
                    <b-button
                        size="sm"
                        variant="danger"
                        class="btn-block"
                        @click="RemoveConnectedVoucher()"
                    >
                      Verbindung aufheben
                    </b-button>
                  </b-form-group>
                </b-dropdown-html>
                <b-dropdown-divider/>
                <b-dropdown-item
                    v-show="vData.BillNumber == null || vData.BillNumber == ''"
                    @click="OpenInvoiceMenu"
                >Rechnung
                </b-dropdown-item>
                <b-dropdown-item
                    v-show="vData.BillNumber != null && vData.BillNumber != ''"
                    @click="ResetBilling"
                >Aus Rechnung zurücksetzen
                </b-dropdown-item>
                <b-dropdown-item
                    v-show="vData.SevDeskCreditNoteId != null && vData.SevDeskCreditNoteId != ''"
                    @click="ResetCreditNote"
                >Aus Gutschrift zurücksetzen
                </b-dropdown-item>
                <b-dropdown-divider/>

                <b-dropdown-divider v-show="R515"/>
                <b-dropdown-item
                    v-show="R515"
                    variant="danger"
                    @click="DeleteVoucher"
                >LÖSCHEN
                </b-dropdown-item>


              </b-dropdown>

              <b-badge
                  class="ml-1 mt-2 float-right" style="color: #e8e8e8; background: #007b8d; cursor: pointer;"
                  @click="$root.$emit('OpenNoteMenu', 'voucher'+vData.Vid)"
              >
                Notiz
              </b-badge>
            </b-col>
          </b-row>
        </b-card-code>
      </b-col>
    </b-row>
    <b-popover
        ref="popover"
        :target="PickupAddressData.popover.street.target"
        :show.sync="PickupAddressData.popover.street.show"
        :disabled.sync="PickupAddressData.popover.street.disabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Adresssuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table responsive="xl"
                 class="row-pointer"
                 :items="PickupAddressData.popover.street.searchList"
                 :fields="PickupAddressData.popover.street.fields"
                 @row-clicked="SelectAddressBySearch"
        />
      </div>
    </b-popover>

    <b-popover
        ref="popover"
        target="PickupAddressData-popoverShow"
        :show.sync="PickupAddressData.popoverShow"
        :disabled.sync="PickupAddressData.popoverDisabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Adresssuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table responsive="xl"
                 class="row-pointer"
                 :items="PickupAddressData.filteredOptions"
                 :fields="AddressSearchData.fields"
                 @row-clicked="SelectPickupAddressByName"
        />
      </div>
    </b-popover>
    <b-popover
        ref="popover"
        target="DestinationAddressData-popoverShow"
        :show.sync="DestinationAddressData.popoverShow"
        :disabled.sync="DestinationAddressData.popoverDisabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Adresssuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>

        <b-table responsive="xl"
                 class="row-pointer"
                 :items="DestinationAddressData.filteredOptions"
                 :fields="AddressSearchData.fields"
                 @row-clicked="SelectDestinationAddressByName"
        />
      </div>
    </b-popover>

    <b-popover
        ref="popover"
        target="Customer-popoverShow"
        :show.sync="CustomerPopover.popover.popoverShow"
        :disabled.sync="CustomerPopover.popover.disabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Kundensuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
              @click="ClosePopoverCustomerSearch"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table responsive="xl"
                 class="row-pointer"
                 :items="CustomerPopover.popover.searchList"
                 :fields="CustomerPopover.popover.fields"
                 @row-clicked="SelectCustomerBySearch"
        >
          <template #cell(Name)="data">
            {{ data.item.Name }} {{ data.item.Contact.Name }}
          </template>
        </b-table>
      </div>
    </b-popover>


    <b-modal
        hide-footer
        id="modal-copy-voucher"
        centered
        size="lg"
        title="Voucher Kopieren"
        no-close-on-backdrop
    >
      <b-row>
        <b-col
            md="12"
            xl="12"
        >
          <b-alert
              variant="warning"
              v-show="vData.ConnectedVoucherId > 0"
              show
          >
            <h4 class="alert-heading">
              Kopiervorgang
            </h4>
            <div class="alert-body">
              <span>Dieser Voucher hat eine Hin- und Rückfahrt. Kopiert wird hier lediglich die fahrt!</span>
            </div>
          </b-alert>
        </b-col>
        <b-col
            md="6"
            xl="6"
        >
          <div v-for="(cvo,index) in copyVoucherOptions">
            <b-form-checkbox
                v-model="copyVoucherOptions[index].value"
                class="custom-control-success mb-1"
            >
              {{ cvo.label }}
            </b-form-checkbox>
          </div>
        </b-col>
        <b-col
            md="6"
            xl="6"
        >
          <m-date-picker style="width: 20em" v-model="copyVoucherDates" :disp="['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.','Jahr', ' Monat', 'Leeren', 'Ok']" :multi="true" :always-display="true" lang="en"></m-date-picker>

        </b-col>

      </b-row>

      <div>
        <b-button
            size="sm"
            variant="gradient-danger"
            class="btn-icon"
            @click="CancelCopyVoucher"
        >
          <feather-icon icon="Trash2Icon"/>
        </b-button>
        <b-button class="float-right" variant="success" @click="SaveCopyVoucher">
          OK
        </b-button>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <div></div>
      </template>
    </b-modal>

    <b-modal
        hide-footer
        id="modal-invoice-voucher"
        centered
        size="xl"
        title="Rechnung"
        no-close-on-backdrop
    >
      <b-row>
        <b-col
            md="12"
            xl="12"
        >
          <b-input-group>
            <b-form-input
                v-model="invoice.filter"
                class="form-control form-control-sm"
                size="sm"
            />
            <template #append>
              <b-button
                  variant="success"
                  @click="LoadInvoiceList()"
                  size="sm"
              >
                <feather-icon
                    size="14"
                    icon="SaveIcon"
                    class="mr-50"
                />
              </b-button>
            </template>
            <hr>
          </b-input-group>
          <b-table
              striped
              hover
              responsive
              :per-page="500"
              :items="invoice.items"
              :fields="invoice.fields"
          >
            <template #cell(BillNumber)="data">
              <b-badge v-if="data.item.InvoiceType == 'RE'" style="color: #e8e8e8; background: #670062">
                Rechnung: {{ data.item.InvoiceNumber }}
              </b-badge>
              <b-badge v-if="data.item.InvoiceType == 'WKR'" style="color: #e8e8e8; background: #670062">
                Wiederkehrende Rechnung: {{ data.item.InvoiceNumber }}
              </b-badge>
              <b-badge v-if="data.item.InvoiceType == 'SR'" style="color: #e8e8e8; background: #ab1800">
                Stornorechnung: {{ data.item.InvoiceNumber }}
              </b-badge>
              <b-badge v-if="data.item.InvoiceType == 'MA'" style="color: #e8e8e8; background: #e39500">
                Rechnungserinnerung: {{ data.item.InvoiceNumber }}
              </b-badge>
              <b-badge v-if="data.item.InvoiceType == 'TR'" style="color: #e8e8e8; background: #670062">
                Teilrechnung: {{ data.item.InvoiceNumber }}
              </b-badge>
              <b-badge v-if="data.item.InvoiceType == 'TR'" style="color: #e8e8e8; background: #670062">
                Schlussrechnung: {{ data.item.InvoiceNumber }}
              </b-badge>
              <b-badge v-if="data.item.InvoiceType == 'CN'" style="color: #e8e8e8; background: #007b8d">
                Gutschrift: {{ data.item.InvoiceNumber }}
              </b-badge>

              <b-form-input v-if="data.item.InvoiceType == null" v-model="data.item.NewBillNumber">

              </b-form-input>
            </template>
            <template #cell(Status)="data">
              <b-badge v-if="data.item.Status == '50'" style="color: #e8e8e8; background: #04dcbc">
                Deaktivierte Dauerrechnung
              </b-badge>
              <b-badge v-if="data.item.Status == '100'" style="color: #e8e8e8; background: #0469dc">
                Entwurf
              </b-badge>
              <b-badge v-if="data.item.Status == '200'" style="color: #e8e8e8; background: #eca100">
                Offen
              </b-badge>
              <b-badge v-if="data.item.Status == '1000'" style="color: #e8e8e8; background: #319400">
                Bezahlt
              </b-badge>
              <b-badge v-if="data.item.Status == null" style="color: #e8e8e8; background: #670062">
                Unbekannte Rechnung
              </b-badge>
            </template>
            <template #cell(Action)="data">

              <b-dropdown
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  class="btn-icon"
                  dropleft
                  variant="flat-success"
              >

                <b-dropdown-item
                    @click="vData.BillNumber = data.item.BillNumber; Save()"
                >

                  <div>
                    <feather-icon
                        icon="CheckIcon"
                        size="22"
                    />
                    Dieser Rechnung zuweisen
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-col>

      </b-row>

      <div>
        <b-button
            size="sm"
            variant="gradient-danger"
            class="btn-icon"
            @click="CancelInvoiceVoucher"
        >
          <feather-icon icon="Trash2Icon"/>
        </b-button>
        <b-button class="float-right" variant="success" @click="SaveInvoiceVoucher">
          OK
        </b-button>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Remark from '@/views/voucher/Remark'
import EuroField from '@/views/voucher2/EuroFild.vue'
import Cleave from 'vue-cleave-component'
import BCardCode from '@core/components/b-card-code'
import {
  BAlert,
  BTable,
  BFormCheckbox,
  BBadge,
  BFormSelect,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
  BPopover,
  BTab,
  BTabs,
  BInputGroupPrepend,
  BInputGroupAppend,
  VBTooltip, BInputGroup, BSpinner, BFormDatepicker
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueAutosuggest } from 'vue-autosuggest'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import price from '../administration/Price.vue'
import ConnectedVoucherBadge from '@/views/extras/ConnectedVoucherBadge.vue'
import router from '@/router'

export default {
  name: 'VoucherMask',
  computed: {
    price() {
      return price
    }
  },
  components: {
    ConnectedVoucherBadge,
    BAlert,
    BFormCheckbox,
    BTab,
    BTabs,
    EuroField,
    BFormSelect,
    Cleave,
    BTable,
    Remark,
    BCardCode,
    VueAutosuggest,
    BPopover,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BBadge,
    BInputGroupPrepend,
    BInputGroupAppend,
    BSpinner,
    BFormDatepicker
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      Drivers: [],
      copyVoucherDates: [],
      copyVoucherOptionsValues: [],
      copyVoucherOptions: [
        {
          value: true,
          label: 'Beschreibung kurz Kopieren',
          name: 'Description1',
        },
        {
          value: true,
          label: 'Beschreibung lang Kopieren',
          name: 'Description2',
        },
        {
          value: true,
          label: 'Bemerkung Pdf Kopieren',
          name: 'DescriptionPdf',
        },
        {
          value: true,
          label: 'Bemerkung Rechnung Kopieren',
          name: 'DescriptionInvoice',
        },
        {
          value: false,
          label: 'Trip Korrektur Kopieren',
          name: 'TripRouteCorrection',
        },
      ],
      ConnectedVoucherData: null,
      R515: false,
      Maps: {
        Pickup: {
          Center: {
            lat: 51.344443,
            lng: 12.381401
          },
          markers: [],
        },
      },
      VehicleMarkers: [],
      PickupMapShow: false,
      showInfo: true,
      infoWindowContext: {
        position: {
          lat: 44.2899,
          lng: 11.8774
        }
      },
      blockCode: '',
      loading: {
        base: false,
        price: false,
        openPdf: false,
      },
      timeout: {
        EuroLoading: null
      },
      zoneName: '',
      AddressSearchData: {
        autoSuggestLimit: 8,
        fields: [
          {
            key: 'AddressId',
            label: 'Kennung',
          },
          {
            key: 'Address.Street',
            label: 'Adresse',
          },
          {
            key: 'Address.Location',
            label: 'Ort',
          },
          {
            key: 'Contact.Name',
            label: 'Name',
          },
          {
            key: 'Contact.Phone',
            label: 'Telefon',
          },
        ],
      },
      SaveButton: null,
      hasErrors: true,
      VatRateLabel: '',
      EndSum: '',
      IsCrewTrip: false,
      options: {
        Time2Label: 'Abflug',
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
        number: {
          numericOnly: true,
          blocks: [16],
          delimiters: ['']
        },

      },
      CustomerPopover: {
        popover: {
          target: 'Customer-popoverShow',
          popoverShow: false,
          disabled: false,
          timeout: null,
          searchList: [],
          lastInput: '',
          fields: [
            {
              key: 'CustomerNumber',
              label: 'Kundennummer',
            },
            {
              key: 'Name',
              label: 'Name',
            },
            {
              key: 'Address.Street',
              label: 'Straße',
            },
            {
              key: 'Address.ZipCode',
              label: 'Plz',
            },
            {
              key: 'Address.Location',
              label: 'Ort',
            },
          ],
        },
      },
      PickupAddressData: {
        filteredOptions: [],
        selected: null,
        popoverShow: false,
        popoverDisabled: true,
        popover: {
          street: {
            target: 'PickupAddressData-Street-popoverShow',
            show: false,
            disabled: false,
            timeout: null,
            searchList: [],
            lastInput: '',
            fields: [
              {
                key: 'Address',
                label: 'Adresse',
              },
              {
                key: 'DistanceMeters',
                label: 'Entfernung',
              },
            ],
          }
        },
      },
      DestinationAddressData: {
        filteredOptions: [],
        autoSuggestLimit: 60,
        selected: null,
        popoverShow: false,
        popoverDisabled: true,
      },
      Equipment: {
        value: {
          IdentId: 0,
          Price: 0,
          Name: '',
        },
        text: '',
      },
      EquipmentPrice: 0,
      EquipmentList: [],
      TransportTicketList: [
        {
          value: false,
          text: 'Nein',
        },
        {
          value: null,
          text: '',
        },
        {
          value: true,
          text: 'Ja',
        }
      ],
      AdditionalPaymentList: [
        {
          value: false,
          text: 'Nein',
        },
        {
          value: null,
          text: '',
        },
        {
          value: true,
          text: 'Ja',
        }
      ],
      Customer: {
        IdentId: 0,
        Number: '',
        Name: ''
      },
      returnTripData: {
        Equipment: 0,
        Passengers: 0,
        PassengersChildren: 0,
        TravelDay: '',
        Flight: {
          Iata: '',
          Departure: '',
          Arrivals: '',
          ScheduledTime: '',
          ExpectedTime: null,
        },
        MedicalTrip: {
          TransportTicket: false,
          AdditionalPayment: false,
          AppointmentTime: '',
          GrossSum: null,
          DmrzId: null,
        },
        PickupTime: '',
        Description1: '',
        Description2: '',
        DescriptionPdf: '',
      },
      NewConnectedVoucherId: 0,
      NewSumUpTransactionCode: "",
      tempId: 0,
      vData: {
        SumUpTransactionCode: "",
        Vid: 0,
        BillNumber: '',
        Passengers: 0,
        Canceled: null,
        CanceledUser: '',
        CanceledBy: 0,
        PassengersChildren: 0,
        Equipment: 0,
        RideType: 0,
        additional_payment: 0,
        TravelDay: '',
        TripRoute: {
          TripDistanceMeter: 0,
          TripFullDistanceMeter: 0,
          TripDuration: 0,
          TripFullDuration: 0,
        },
        TripRouteCorrection: {
          TripDistanceMeter: 0,
          TripFullDistanceMeter: 0,
          TripDuration: 0,
          TripFullDuration: 0,
        },
        Flight: {
          Iata: '',
          DepartureName: '',
          Departure: '',
          Arrivals: '',
          ArrivalsName: '',
          ScheduledTime: '',
          ScheduledTimeCorrected: '',
          ExpectedTime: null,
        },
        MedicalTrip: {
          TransportTicket: null,
          AdditionalPayment: null,
          AppointmentTime: '',
          GrossSum: null,
          DmrzId: null,
        },
        PickupTime: '',
        Taxipreis: 0,
        MedicalPrice: 0,
        PriceExtra: 0,
        Price: 0,
        PaymentMethod: 0,
        Customer: 0,
        ConnectedVoucherId: 0,
        PickUpPassengerIdentId: 0,
        PickUpPassengerNumber: '',
        DestinationPassengerIdentId: 0,
        DestinationPassengerNumber: '',
        PickUpAddressContact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: '',
        },
        PickUpAddress: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: '',
        },
        DestinationAddressContact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: '',
        },
        DestinationAddress: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: '',
        },
        Description1: '',
        Description2: '',
        DescriptionInvoice: '',
        DescriptionPdf: '',
      },
      TravelDayName: '',
      ReturnTravelDayName: '',
      returnTrip: false,
      TripType: 0,
      intervalVehicleUpdate: null,
      invoice: {
        filter: '',
        items: [],
        fields: [
          {
            key: 'BillNumber',
            label: 'R.Nr.',
          },
          {
            key: 'Date',
            label: 'Datum',
          },
          {
            key: 'Status',
            label: 'Status',
          },
          {
            key: 'From',
            label: 'von Datum',
          },
          {
            key: 'To',
            label: 'Bis Datum',
          },
          {
            key: 'Customer',
            label: 'Kunde',
          },
          {
            key: 'NetSum',
            label: 'Netto',
          },
          {
            key: 'GrossSum',
            label: 'Brutto',
          },
          {
            key: 'VoucherCount',
            label: 'Fahrten',
          },
          {
            key: 'Action',
            label: '',
          }
        ]
      }
    }
  },
  mounted() {
    let i = this
    clearInterval(this.intervalVehicleUpdate)
    this.UpdateVehicleMarker()
    // this.intervalVehicleUpdate = setInterval(function () {
    //   i.UpdateVehicleMarker()
    // }, 30000)

    this.$nextTick(() => {
      document.title = 'V: ' + this.$route.params.id
      this.HasUserDeleteRight()
    })
    ConvertTravelDate: {
      let d = new Date()
      let ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(d)
      let mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
      let da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
      //this.vData.TravelDay = `${da}.${mo}.${ye}`
    }
    Load: {
      this.blockCode = this.MakeBlockCode(24)

      this.ChangeRideType(0)
      if (this.LoadEquipmentList()) {
        this.LoadVoucher()
      }
    }
    this.$nextTick(() => this.$refs.PickUpPassengerNumber.$el.select())
    this.Watch()
    EnterEvent: {
      window.addEventListener('keydown', function (event) {
        // If down arrow was pressed...
        if (event.key == 'Enter') {
          if (this.hasErrors == false) {
          }

        }
      }.bind(this), false)
    }
  },
  methods: {
    router() {
      return router
    },

    OpenVoucher(vid) {
      this.$router.push({ name: 'Blank' })
      this.$nextTick(() => {
        this.$router.push({
          name: 'VoucherMask',
          params: { id: vid }
        })
      })
    },
    formatDate(date) {
      return data.toLocaleDateString()
    },
    SaveCopyVoucher() {
      var options = {}
      this.copyVoucherOptions.forEach(i => {
        console.log(i)
        options[i.name] = i.value
      })

      let cD = {
        Voucher: this.vData.Vid,
        Dates: this.copyVoucherDates,
        Options: options,
      }
      this.$http.post('/voucher/copy', cD)
          .then(resp => {
            let vids = 'Vid\'s '
            resp.data.newVouchers.forEach(i => {
              vids = vids + ' ' + i
            })
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Kopieren erfolgreich ' + vids + '.',
                  variant: 'success',
                },
              })
            }
            console.log(resp)
          })
          .catch(err => {
            console.error(err)
          })

      this.$bvModal.hide('modal-copy-voucher')
      this.copyVoucherDates = []
    },
    CancelCopyVoucher() {

      this.$bvModal.hide('modal-copy-voucher')
      this.copyVoucherDates = []
    },
    LoadInvoiceList() {
      this.invoice.items = []
      let url = `/invoice/list?from=0&count=10`
      console.log(this.invoice.filter)
      if (this.invoice.filter && this.invoice.filter != '') {
        url = `/invoice/list?from=0&count=10&filter=${this.invoice.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              let d = new Date(i.From)
              let ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(d)
              let mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
              let da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
              i.From = `${da}.${mo}.${ye}`
              d = new Date(i.To)
              ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(d)
              mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
              da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
              i.To = `${da}.${mo}.${ye}`
              d = new Date(i.Date)
              ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(d)
              mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
              da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
              i.Date = `${da}.${mo}.${ye}`
              i.Customer = i.Customer.CustomerNumber + ' - ' + i.Customer.Name

              this.invoice.items.push(i)
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
    ResetBilling() {
      this.$http.get('/voucher/set/invoice?vid=' + this.vData.Vid + '&sevDeskInvoiceId=0')
          .then(resp => {
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Ok',
                  icon: 'error',
                  text: 'Aus Rechnung zurückgesetzt',
                  variant: 'success',
                },
              })
            }

          })
          .catch(err => {
            console.error(err)
          })

    },
    ResetCreditNote() {
      this.$http.get('/voucher/set/creditNote?vid=' + this.vData.Vid + '&sevDeskCreditNoteId=0')
          .then(resp => {
                if (resp.data.success) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Ok',
                      icon: 'error',
                      text: 'Aus Gutschrift zurückgesetzt',
                      variant: 'success',
                    },
                  })
                }

          })
          .catch(err => {
            console.error(err)
          })
    },
    SaveInvoiceVoucher() {
      this.$bvModal.hide('modal-invoice-voucher')
    },
    CancelInvoiceVoucher() {
      this.$bvModal.hide('modal-invoice-voucher')
    },
    OpenInvoiceMenu() {
      this.LoadInvoiceList()
      this.$bvModal.show('modal-invoice-voucher')
    },
    OpenCopyMenu() {
      this.$bvModal.show('modal-copy-voucher')
    },

    GetGoogleMaps() {
      return `https://www.google.com/maps/dir/${this.vData.PickUpAddress.Street} ${this.vData.PickUpAddress.ZipCode} ${this.vData.PickUpAddress.Location}/${this.vData.DestinationAddress.Street} ${this.vData.DestinationAddress.ZipCode} ${this.vData.DestinationAddress.Location}`
    },

    SaveConnectedVoucher() {
      this.$http.get('/voucher/connect?vid=' + this.vData.Vid + '&connectVid=' + this.NewConnectedVoucherId)
          .then(resp => {
            console.log(resp.data)
            if (resp.data.success) {
              this.vData.ConnectedVoucherId = this.NewConnectedVoucherId
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Ok',
                  icon: 'error',
                  text: 'Voucher verbunden',
                  variant: 'success',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'error',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    SaveSumup() {
      this.$http.get('/voucher/set/sumup?vid=' + this.vData.Vid + '&sumUpTransactionCode=' + this.vData.SumUpTransactionCode)
          .then(resp => {
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Ok',
                  icon: 'error',
                  text: 'Sumup gesetzt',
                  variant: 'success',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'error',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    async GetConnectedVoucherData(connectedId) {
      if(connectedId > 0)
        await this.$http.get(`/voucher/connected/data/?voucherId=${connectedId}`)
          .then(resp => {
            this.ConnectedVoucherData = resp.data.data.ConnectedVoucher;
          })
          .catch(err => {
            console.error(err)
          })
    },
    RemoveConnectedVoucher() {
      this.$http.get('/voucher/connect?vid=' + this.vData.Vid + '&connectVid=0')
          .then(resp => {
            console.log(resp.data)
            if (resp.data.success) {
              this.vData.ConnectedVoucherId = 0
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Ok',
                  icon: 'error',
                  text: 'Voucher getrennt',
                  variant: 'success',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'error',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    setLoadingBar() {
      console.log('TEST')
      this.loading.base = true
      clearTimeout(this.timeout.EuroLoading)
      this.timeout.EuroLoading = setTimeout(() => {
        this.loading.base = false
      }, 500)
    },
    Audio(name) {
      let audio = new Audio(require('@/assets/audio/' + name))
      audio.play()
    },
    MakeBlockCode(length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },

    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.vData.TravelDay = ctx.activeFormatted
        this.NextInput('TravelDay')
      }
    },
    onDateFromReturnContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.returnTripData.TravelDay = ctx.activeFormatted
        this.NextInput('ReturnTravelDay')
      }
    },
    FormatTime(time) {
      if(time != undefined && time.length >= 5) {
        return time.substring(0,5)
      }
      return "-"
    },
    NextInput(current, type = '') {
      console.log(current)
      if (current == 'Passengers') {
        if (this.vData.Passengers > 0) {
          this.$nextTick(() => this.$refs.PassengersChildren.$el.select())
          if (this.returnTripData.Passengers == 0 && this.vData.Vid == 0) {
            this.returnTripData.Passengers = this.vData.Passengers
          }
        } else {
          this.Audio('error-129258.mp3')
        }
      }
      if (current == 'ReturnPassengers') {
        if (this.vData.Passengers > 0) {
          this.$nextTick(() => this.$refs.ReturnPassengersChildren.$el.select())
        } else {
          this.Audio('error-129258.mp3')
        }
      }
      if (current == 'PassengersChildren') {
        if (parseInt(this.vData.PassengersChildren) >= 0) {
          if (this.returnTripData.PassengersChildren == 0) {
            this.returnTripData.PassengersChildren = this.vData.PassengersChildren
          }

          if (this.vData.RideType == 0) {
            this.$nextTick(() => this.$refs.Iata.$el.select())
          }
          if (this.vData.RideType == 1) {
            this.$nextTick(() => this.$refs.TransportTicket.$el.focus())
          }
          if (this.vData.RideType == 2) {
            this.$nextTick(() => this.$refs.PickupTime2.$el.select())
          }
        } else {
          this.Audio('error-129258.mp3')
        }
      }
      if (current == 'ReturnPassengersChildren') {
        if (this.returnTripData.PassengersChildren == 0) {
          this.returnTripData.PassengersChildren = this.vData.PassengersChildren
        }

        if (this.vData.RideType == 0) {
          this.$nextTick(() => this.$refs.ReturnIata.$el.select())
        }
        if (this.vData.RideType == 1) {

          this.$nextTick(() => this.$refs.ReturnPickupTime1.$el.focus())
        }
        if (this.vData.RideType == 2) {
          this.$nextTick(() => this.$refs.ReturnPickupTime2.$el.select())
        }
      }
      if (current == 'Iata' && type == '') {
        this.$nextTick(() => this.$refs.PickupTime0.$el.select())
      }
      if (current == 'Iata' && type == 'Arrivals') {
        this.$nextTick(() => this.$refs.Arrivals.$el.select())
      }
      if (current == 'ReturnIata' && type == '') {
        this.$nextTick(() => this.$refs.ReturnPickupTime0.$el.select())
      }
      if (current == 'ReturnIata' && type == 'ReturnArrivals') {
        this.$nextTick(() => this.$refs.ReturnArrivals.$el.select())
      }
      if (current == 'PickupTime') {
        if (this.vData.PickupTime.length != 5) {
          this.Audio('error-129258.mp3')
        } else {
          if (this.vData.RideType == 0) {
            this.$nextTick(() => this.$refs.ScheduledTime0.$el.select())
          }
          if (this.vData.RideType == 1) {
            this.$nextTick(() => this.$refs.ScheduledTime1.$el.select())
          }
          if (this.vData.RideType == 2) {
            this.$nextTick(() => this.$refs.ScheduledTime2.$el.select())
          }
        }
      }
      if (current == 'TransportTicket') {
        this.$nextTick(() => this.$refs.AdditionalPayment.$el.focus())
      }
      if (current == 'AdditionalPayment') {
        this.$nextTick(() => this.$refs.PickupTime1.$el.select())
      }
      if (current == 'ReturnTransportTicket') {
        this.$nextTick(() => this.$refs.ReturnAdditionalPayment.$el.focus())
      }
      if (current == 'ReturnAdditionalPayment') {
        this.$nextTick(() => this.$refs.ReturnPickupTime1.$el.select())
      }
      if (current == 'ReturnPickupTime') {
        if (this.returnTripData.PickupTime.length != 5) {
          this.Audio('error-129258.mp3')
        } else {
          if (this.vData.RideType == 0) {
            this.$nextTick(() => this.$refs.ReturnScheduledTime0.$el.select())
          }
          if (this.vData.RideType == 1) {
            this.$nextTick(() => this.$refs.ReturnScheduledTime1.$el.select())
          }
          if (this.vData.RideType == 2) {
            this.$nextTick(() => this.$refs.ReturnScheduledTime2.$el.select())
          }
        }
      }
      if (current == 'Departure') {
        this.$nextTick(() => this.$refs.Arrivals.$el.select())
      }
      if (current == 'Arrivals') {
        this.$nextTick(() => this.$refs.PickupTime0.$el.select())
      }
      if (current == 'ReturnDeparture') {
        this.$nextTick(() => this.$refs.ReturnArrivals.$el.select())
      }
      if (current == 'ReturnArrivals') {
        this.$nextTick(() => this.$refs.ReturnPickupTime0.$el.select())
      }

      if (current == 'ScheduledTime') {
        this.$nextTick(() => this.$refs.Description.$el.select())
      }
      if (current == 'Description') {
        this.vData.DescriptionInvoice = this.vData.Description1
        this.vData.DescriptionPdf = this.vData.Description1
        this.$nextTick(() => this.$refs.Description2.$el.select())
      }
      if (current == 'Description2') {
        this.$nextTick(() => this.$refs.DescriptionPdf.$el.select())
      }
      if (current == 'DescriptionPdf') {
        if (this.IsCrewTrip || this.vData.Vid > 0) {
          this.returnTripData.Passengers = 0
          this.$nextTick(() => this.$refs.CustomerNumber.$el.select())
        } else {
          this.Audio('interface-124464.mp3')
          this.TripType = 1
          this.$nextTick(() => this.$refs.ReturnTravelDay.$el.select())
        }

      }
      if (current == 'TravelDay') {

        if(!this.isValidDate(this.vData.TravelDay)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Das Datum ist ungültig',
              icon: 'EditIcon',
              variant: 'error',
            },
          })
          return;
        }
        const date = this.vData.TravelDay.split('.')
        let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
        this.vData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
              year: '2-digit',
              month: '2-digit',
              day: '2-digit'
            },
        )
        this.TravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
              weekday: 'long',
            },
        ) + ','

        this.filterTimeout = setTimeout(() => {
          this.$nextTick(() => this.$refs.Passengers.$el.select())
        }, 100)
      }
      if (current == 'ReturnTravelDay' && type == '') {
        if(this.returnTripData.TravelDay != "" && !this.isValidDate(this.returnTripData.TravelDay)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Das Datum ist ungültig',
              icon: 'EditIcon',
              variant: 'error',
            },
          })
          return;
        }
        if(this.returnTripData.TravelDay == "") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Buchung hat keine Rückfahrt',
              icon: 'EditIcon',
              variant: 'info',
            },
          })
          this.NextInput('ReturnTravelDay', 'cancel')
          return
        }
        const date = this.returnTripData.TravelDay.split('.')
        let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
        this.returnTripData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
              year: '2-digit',
              month: '2-digit',
              day: '2-digit'
            },
        )
        this.ReturnTravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
              weekday: 'long',
            },
        ) + ','

        this.filterTimeout = setTimeout(() => {
          this.$nextTick(() => this.$refs.ReturnPassengers.$el.select())
        }, 100)

      }
      if (current == 'ReturnTravelDay' && type == 'cancel') {
        this.$refs.CustomerNumber.$el.select()
        this.returnTripData.Passengers = 0
        this.returnTripData.PassengersChildren = 0
        this.TripType = 0
      }

      if (current == 'ReturnDescriptionPdf') {
        this.$refs.CustomerNumber.$el.select()
      }
      if (current == 'CustomerNumber') {
        this.$refs.EuroFieldPrice.Focus()
      }
      if (current == 'DescriptionInvoice') {
        console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX')
      }
    },
    NumberOnlyAndAddDay(ev) {
      const isNumber = /^[0-9]$/i.test(ev.key)
      if (ev.key == '+' || ev.key == '-') {
        const date = this.vData.TravelDay.split('.')
        if (date[0].length == 2 && date[1].length == 2 && date[2].length == 2) {
          let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
          if (ev.key == '+') {
            TravelDay.setDate(TravelDay.getDate() + 1)
          }
          if (ev.key == '-') {
            TravelDay.setDate(TravelDay.getDate() - 1)
          }

          this.vData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit'
              },
          )
          this.TravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
                weekday: 'long',
              },
          ) + ','

        }
      }
      return false
    },
    NumberOnlyAndAddDay2(ev) {
      const isNumber = /^[0-9]$/i.test(ev.key)
      if (ev.key == '+' || ev.key == '-') {
        const date = this.returnTripData.TravelDay.split('.')
        if (date[0].length == 2 && date[1].length == 2 && date[2].length == 2) {
          let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
          if (ev.key == '+') {
            TravelDay.setDate(TravelDay.getDate() + 1)
          }
          if (ev.key == '-') {
            TravelDay.setDate(TravelDay.getDate() - 1)
          }

          this.returnTripData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit'
              },
          )
          this.ReturnTravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
                weekday: 'long',
              },
          ) + ','

        }
      }
      return false
    },
    FormatTravelDay() {
      const date = this.vData.TravelDay.split('.')
      let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
      this.vData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit'
          },
      )
      this.TravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
            weekday: 'long',
          },
      ) + ','

      this.returnTripData.TravelDay = new Date(TravelDay).toLocaleString('de-DE', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit'
          },
      )
      this.ReturnTravelDayName = new Date(TravelDay).toLocaleString('de-DE', {
            weekday: 'long',
          },
      ) + ','
    },
    ChangeRideType(type) {
      this.vData.RideType = type

      if (this.vData.RideType == 99) {
        this.vData.RideType = 0
        this.IsCrewTrip = true
        localStorage.lastVoucher_IsCrewTrip = true
      }

      if (this.vData.RideType == 88) {
        if (localStorage.lastVoucher == undefined) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Es gibt keine letzte eingabe',
              icon: 'EditIcon',
              variant: 'error',
            },
          })
          this.RouterBack()
          return
        }

        this.vData = JSON.parse(localStorage.lastVoucher)
        this.vData.Vid = 0
        setTimeout(() => {
          this.$nextTick(() => {

            this.$http.get(`/customer/customerId/${this.vData.Customer}`)
                .then(resp => {
                  this.Customer.Name = resp.data.Name
                  this.Customer.Number = resp.data.CustomerNumber
                  this.Customer.IdentId = this.vData.Customer
                  this.LoadCustomer()
                })
                .catch(err => {
                  console.error(err)
                })

            this.$nextTick(() => this.$refs.TravelDay.$el.select())
            this.IsCrewTrip = localStorage.lastVoucher_IsCrewTrip
          })
        }, 500)
      }
      localStorage.lastVoucher_RideType = this.vData.RideType
      if (this.vData.RideType == 2) {
        this.options.Time2Label = 'Wunsch Ank.'
      }
      if (this.vData.RideType == 1) {
        this.options.Time2Label = 'Terminzeit'
      }
      if (this.vData.RideType == 0) {
        this.options.Time2Label = 'Abflug'
      }
    },
    PriceCheck() {
      this.$swal({
        title: 'Preis Check',
        text: 'Soll der Fahrpreis neu berechnet werden?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nein, überspringen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            this.GetPrice(result.isConfirmed)
            this.SelectInput('DescriptionInvoice')
          })
    },
    async GetPrice(setPrice = true) {
      this.loading.price = true
      await this.CalculatePrice(setPrice)
      const passengers = parseInt(this.vData.Passengers) + parseInt(this.vData.PassengersChildren)
      if (this.vData.DestinationPassengerIdentId > 0 && this.vData.PickUpPassengerIdentId > 0) {
        this.$http.get(`/address/price/variation/find?address1=${this.vData.DestinationPassengerIdentId}&address2=${this.vData.PickUpPassengerIdentId}`)
            .then(resp => {
              if (resp.data.success) {
                resp.data.pv.List.forEach(i => {
                  if (passengers >= i.MinPassengers && passengers <= i.MaxPassengers) {
                    if(setPrice) {
                      this.$refs.EuroFieldPrice.fieldData = i.Price
                      this.CalculateVat()
                      this.zoneName = 'Preisvariation ' + resp.data.pv.IdentId
                    }

                  }
                })
              } else {
                this.CalculatePrice(setPrice)
              }

            })
            .catch(err => {
            })
      } else {
        this.CalculatePrice(setPrice)
      }

      this.loading.price = false
    },
    ConfirmVoucher(vid) {
      this.$http.post('/voucher/confirm', parseInt(vid))
          .then(resp => {
            console.log(resp)
          })
          .catch(err => {
            console.error(err)
          })
      console.log(vid)
    },
    Watch() {
      console.log('Start Watch')
      this.$watch(
          () => this.$refs.EuroFieldPrice.watch,
          val => {
            this.CalculateVat()
            this.$refs.EuroFieldExtraPrice.Focus()
          },
      )
      this.$watch(
          () => this.vData.MedicalTrip.AdditionalPayment,
          val => {
            this.returnTripData.MedicalTrip.AdditionalPayment = this.vData.MedicalTrip.AdditionalPayment
          },
      )
      this.$watch(
          () => this.vData.MedicalTrip.TransportTicket,
          val => {
            this.returnTripData.MedicalTrip.TransportTicket = this.vData.MedicalTrip.TransportTicket
          },
      )
      this.$watch(
          () => this.$refs.MedicalTripPrice.watch,
          val => {
            this.vData.MedicalTrip.GrossSum = this.$refs.MedicalTripPrice.fieldData
            this.returnTripData.MedicalTrip.GrossSum = this.$refs.MedicalTripPrice.fieldData
            this.$refs.MedicalTripPrice.Focus()
          },
      )

      this.$watch(
          () => document.activeElement,
          val => {
            console.log(document.activeElement)
          },
      )
      this.$watch(
          () => this.$refs.EuroFieldExtraPrice.watch,
          val => {
            this.CalculateVat()
            this.$refs.DescriptionInvoice.$el.select()
          },
      )
    },
    ClosePopover() {
      setTimeout(() => {
        this.PickupAddressData.popoverShow = false
        this.DestinationAddressData.popoverShow = false
      }, 500)
    },
    ClosePopoverStreet() {
      setTimeout(() => {
        this.PickupAddressData.popover.street.show = false
      }, 500)
    },
    async SearchPickupAddressByName(value) {
      this.PickupAddressData.filteredOptions = []
      this.PickupAddressData.filteredOptions = await this.SearchAddressByName(value)
      this.PickupAddressData.popoverShow = true
    },
    async SearchDestinationAddressByName(value) {
      this.DestinationAddressData.filteredOptions = []
      this.DestinationAddressData.filteredOptions = await this.SearchAddressByName(value)
      this.DestinationAddressData.popoverShow = true
    },
    ClosePopoverCustomerSearch() {
      setTimeout(() => {
        this.CustomerPopover.popover.popoverShow = false
        console.log('CLOSE')
      }, 500)

    },
    async SearchCustomerByName(value) {

      clearTimeout(this.CustomerPopover.popover.timeout)
      this.CustomerPopover.popover.timeout = setTimeout(() => {
        let data = []
        this.$http.get('/customer/list/filter?filter=' + value + '&count=15')
            .then(resp => {
              resp.data.list.forEach(i => {
                data.push(i)
              })
            })
            .catch(err => {
              console.error(err)
            })

        this.CustomerPopover.popover.searchList = data
        this.CustomerPopover.popover.popoverShow = true
      }, 500)

    },
    async SearchAddressByName(value) {
      let rData = []
      this.$http.post('/address', JSON.stringify({
        Value: value,
      }))
          .then(resp => {
            let count = 0
            resp.data.forEach(i => {
              if (count > this.AddressSearchData.autoSuggestLimit) {
                return
              }

              rData.push(i)
              count++
            })
          })
          .catch(err => {
            console.error(err)
          })
      return rData
    },
    SelectAddress(number, type) {
      this.$http.get(`/address/${number}`)
          .then(resp => {
            this.PickupAddressData.popoverShow = false
            this.DestinationAddressData.popoverShow = false
            if (resp.data.success == false) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Adresse wurde nicht im System gefunden.',
                  variant: 'warning',
                },
              })
            } else {
              let AddressFields = {}
              let ContactFields = {}
              if (type == 'pickup') {
                AddressFields = this.vData.PickUpAddress
                ContactFields = this.vData.PickUpAddressContact
                this.vData.PickUpPassengerNumber = resp.data.AddressId
                this.vData.PickUpPassengerIdentId = resp.data.AddressIdentId

              }
              if (type == 'destination') {
                this.vData.DestinationPassengerNumber = resp.data.AddressId
                this.vData.DestinationPassengerIdentId = resp.data.AddressIdentId
                AddressFields = this.vData.DestinationAddress
                ContactFields = this.vData.DestinationAddressContact
              }

              AddressFields.Street = resp.data.Address.Street
              AddressFields.ZipCode = resp.data.Address.ZipCode
              AddressFields.Location = resp.data.Address.Location
              AddressFields.District = resp.data.Address.District
              ContactFields.Name = resp.data.Contact.Name
              ContactFields.Phone = resp.data.Contact.Phone
              ContactFields.Phone2 = resp.data.Contact.Phone2
              ContactFields.Fax = resp.data.Contact.Fax
              ContactFields.Web = resp.data.Contact.Web
              ContactFields.Email = resp.data.Contact.Email
              if (type == 'pickup') {
                this.$nextTick(() => this.$refs.DestinationPassengerNumber.$el.select())
              } else {
                this.$nextTick(() => this.$refs.TravelDay.$el.select())
              }

            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    checkMobile() {
      console.log(navigator.userAgent)
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    SelectPickupAddressById(event, typ) {
      if (typ == 2 && !this.checkMobile()) {
        return
      }

      if (event.keyCode == 13) {
        this.SelectAddress(this.vData.PickUpPassengerNumber, 'pickup')
        localStorage.lastVoucher_PickUpPassengerNumber = this.vData.PickUpPassengerNumber
      }
      if (event.type == 'blur') {
        if (localStorage.lastVoucher_PickUpPassengerNumber == this.vData.PickUpPassengerNumber) {
          return
        }

        this.SelectAddress(this.vData.PickUpPassengerNumber, 'pickup')
        localStorage.lastVoucher_PickUpPassengerNumber = this.vData.PickUpPassengerNumber
      }
      console.log(event)
    },
    SelectPickupAddressByName(row) {
      this.SelectAddress(row.AddressId, 'pickup')
      this.$nextTick(() => this.$refs.TravelDay.$el.select())
    },
    SelectAddressBySearch(row) {
      this.SelectSearchAddress(row)
    },
    SelectDestinationAddressById(event, typ) {
      if (event.type == 'blur' && !this.checkMobile()) {
        return
      }

      if (event.keyCode == 13) {
        this.SelectAddress(this.vData.DestinationPassengerNumber, 'destination')
        localStorage.lastVoucher_DestinationPassengerNumber = this.vData.DestinationPassengerNumber
      }

      if (event.type == 'blur') {
        if (localStorage.lastVoucher_DestinationPassengerNumber == this.vData.DestinationPassengerNumber) {
          return
        }

        this.SelectAddress(this.vData.DestinationPassengerNumber, 'destination')
        localStorage.lastVoucher_DestinationPassengerNumber = this.vData.DestinationPassengerNumber
      }
    },
    SelectTravelDate(event) {
      if (event.keyCode == 13) {
        this.SelectAddress(this.vData.DestinationPassengerNumber, 'destination')
        this.$nextTick(() => this.$refs.TravelDay.$el.select())
      }
    },
    SelectDestinationAddressByName(row) {
      this.SelectAddress(row.AddressId, 'destination')
      this.$nextTick(() => this.$refs.TravelDay.$el.select())

    },
    SelectCustomerBySearch(row) {
      this.Customer.Number = row.CustomerNumber

      this.LoadCustomer()
    },
    OpenPopover(name) {
      if (name == 'destinationStreet') {
        console.log(name + ' *')
        this.PickupAddressData.popover.street.target = 'DestinationAddressData-Street-popoverShow'
      } else {

        console.log(name + ' #')
        this.PickupAddressData.popover.street.target = 'PickupAddressData-Street-popoverShow'
      }

      this.$nextTick(() => {
        this.PickupAddressData.popover.street.show = true
        clearTimeout(this.PickupAddressData.popover.street.timeout)
        this.PickupAddressData.popover.street.timeout = setTimeout(() => {
          this.SearchAddress(name)
        }, 500)
      })
    },
    SelectSearchAddress(searchString) {
      this.$http.post('/address/place/google', JSON.stringify({
        PlaceId: searchString.PlaceId,
      }))
          .then(resp => {

            if (resp.data.success) {
              if (this.PickupAddressData.popover.street.lastInput == 'pickupStreet') {
                if (this.vData.PickUpAddressContact.Name == '') {
                  let sp = searchString.Address.split(',')
                  this.vData.PickUpAddressContact.Name = sp[0]
                }
                this.vData.PickUpAddress.Street = resp.data.Address.Street
                this.vData.PickUpAddress.ZipCode = resp.data.Address.ZipCode
                this.vData.PickUpAddress.Location = resp.data.Address.Location
                this.vData.PickUpAddress.District = resp.data.Address.District
              }

              if (this.PickupAddressData.popover.street.lastInput == 'destinationStreet') {
                if (this.vData.DestinationAddress.Name == '') {
                  let sp = searchString.Address.split(',')
                  this.vData.DestinationAddressContact.Name = sp[0]
                }
                this.vData.DestinationAddress.Street = resp.data.Address.Street
                this.vData.DestinationAddress.ZipCode = resp.data.Address.ZipCode
                this.vData.DestinationAddress.Location = resp.data.Address.Location
                this.vData.DestinationAddress.District = resp.data.Address.District
              }
              console.log(resp)

              this.$nextTick(() => this.setCaretPosition(this.$refs.PickupAddressStreet.$el, 5))

            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    SearchAddress(type) {
      this.PickupAddressData.popover.street.lastInput = type
      let Zipcode = ''
      let Location = ''
      let Street = ''
      if (type == 'pickupStreet') {
        Zipcode = this.vData.PickUpAddress.ZipCode
        Location = this.vData.PickUpAddress.Location != '' ? this.vData.PickUpAddress.Location + ' ' : ''
        Street = this.vData.PickUpAddress.Street != '' ? this.vData.PickUpAddress.Street + ' ' : ''
      } else {
        Zipcode = this.vData.DestinationAddress.ZipCode != '' ? this.vData.DestinationAddress.ZipCode + ' ' : ''
        Location = this.vData.DestinationAddress.Location != '' ? this.vData.DestinationAddress.Location + ' ' : ''
        Street = this.vData.DestinationAddress.Street != '' ? this.vData.DestinationAddress.Street + ' ' : ''
      }

      this.PickupAddressData.popover.street.searchList = []
      if (Street.length < 5) {
        return
      }
      this.$http.post('/address/search/address', JSON.stringify({
        Zipcode: Zipcode,
        Location: Location,
        Street: Street,
      }))
          .then(resp => {
            if (resp.data.success) {
              resp.data.list.forEach(i => {
                this.PickupAddressData.popover.street.searchList.push(i)
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    Cancel() {
      this.$swal({
        title: 'STORNIEREN',
        text: 'Möchten Sie diesen Voucher wirklich stornieren?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, stornieren!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.isConfirmed) {
              this.$http.post('/voucher/cancel', JSON.stringify(this.vData.Vid))
                  .then(resp => {
                    console.log(resp)
                    if (resp.data.success) {
                      this.LoadVoucher()
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: 'Voucher wurde storniert.',
                          variant: 'success',
                        },
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            }
          })
    },

    UndoCancel() {
      this.$http.post('/voucher/undocancel', JSON.stringify(this.vData.Vid))
          .then(resp => {
            if (resp.data.success) {
              this.LoadVoucher()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Voucher wurde entstorniert.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    DeleteVoucher() {
      this.$swal({
        title: 'LÖSCHEN',
        text: 'Möchten Sie diesen Voucher wirklich löschen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, LÖSCHEN!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            console.log(result)
            if (result.isConfirmed) {
              this.$http.post('/voucher/delete', JSON.stringify(this.vData.Vid))
                  .then(resp => {
                    if (resp.data.success) {

                      this.RouterBack();
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Speichern',
                          icon: 'CheckIcon',
                          text: 'Voucher wurde gelöscht.',
                          variant: 'warning',
                        },
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Abbruch',
                  icon: 'CheckIcon',
                  text: 'Vorgang abgebrochen.',
                  variant: 'warning',
                },
              })
            }
          })
    },
    OpenPdf() {
      if (this.vData.Vid > 0) {
        this.loading.openPdf = true
        let url = `/voucher/get/pdf/live/${this.vData.Vid}`
        this.$http.get(url, { responseType: 'blob', timeout: 15000 })
            .then(resp => {
              console.log(resp)
              if (resp.data.type == 'application/pdf') {
                this.loading.openPdf = false
                window.open(URL.createObjectURL(resp.data))
              } else {
                // setTimeout(() => {
                //   this.OpenPdf()
                // }, 1000)
              }

            })
            .catch(error => {
              this.loading.openPdf = true
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: 'Es ist ein Fehler aufgetreten. Bitte versuchen Aie es erneut.',
                  variant: 'danger',
                },
              })


              this.loading.openPdf = false;
              if (error.code === 'ECONNABORTED') {
                // Hier wird die Fehlerbehandlung für Zeitüberschreitung durchgeführt
                console.log('Die Anfrage wurde aufgrund eines Timeouts abgebrochen.');
                // Weitere Maßnahmen bei Timeout möglich
              } else {
                // Andere Fehler behandeln
                console.error('Fehler bei der Anfrage:', error.message);
              }
            })
      }
    },
    OpenProvisionalPdf() {
      if (this.vData.Vid > 0) {
        this.loading.openPdf = true
        let url = `/voucher/get/pdf/provisional/live/${this.vData.Vid}`
        this.$http.get(url, { responseType: 'blob', timeout: 15000 })
            .then(resp => {
              console.log(resp)
              if (resp.data.type == 'application/pdf') {
                this.loading.openPdf = false
                window.open(URL.createObjectURL(resp.data))
              } else {
                // setTimeout(() => {
                //   this.OpenPdf()
                // }, 1000)
              }

            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: 'Es ist ein Fehler aufgetreten. Bitte versuchen Aie es erneut.',
                  variant: 'danger',
                },
              })

              this.loading.openPdf = false;
              if (error.code === 'ECONNABORTED') {
                // Hier wird die Fehlerbehandlung für Zeitüberschreitung durchgeführt
                console.log('Die Anfrage wurde aufgrund eines Timeouts abgebrochen.');
                // Weitere Maßnahmen bei Timeout möglich
              } else {
                // Andere Fehler behandeln
                console.error('Fehler bei der Anfrage:', error.message);
              }

            })
      }
    },
    OpenPdfInvoice() {
      if (this.vData.Vid > 0 && this.vData.PaymentMethod == 3) {
        let url = `/voucher/get/receipt/pdf/${this.vData.Vid}`
        this.$http.get(url, { responseType: 'blob' })
            .then(resp => {
              if (resp.data.type == 'application/json') {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Info',
                    icon: 'CheckIcon',
                    text: 'Quittung wurde noch nicht geschrieben.',
                    variant: 'warning',
                  },
                })
              }
              if (resp.data.type == 'application/pdf') {
                window.open(URL.createObjectURL(resp.data))
              }

            })
            .catch(err => {
              console.error(err)
            })
      }
    },
    OpenLogs() {
      this.$router.push({
        name: 'VoucherLogList',
        params: { vid: this.$route.params.id }
      })
    },
    async LoadEquipmentList() {
      this.EquipmentList.push(this.Equipment)
      await this.$http.get('equipment/list')
          .then(resp => {
            resp.data.forEach(i => {
              this.EquipmentList.push({
                value: i.Value,
                text: i.Value.Name,
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    SelectTransportTicket() {
      this.NextInput('TransportTicket')
      if (this.vData.Customer > 0) {

        this.CalculatePrice()
        if (this.vData.MedicalTrip.TransportTicket) {
          this.vData.Price = 0
          this.$refs.EuroFieldPrice.fieldData = 0
          this.CalculateVat()
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Achtung',
            icon: 'CheckIcon',
            text: 'Preis passt sich automatich an.',
            variant: 'warning',
          },
        })
      }
    },
    SelectAdditionalPayment() {
      this.NextInput('AdditionalPayment')
    },
    SelectEquipment() {
      this.EquipmentList.forEach(i => {
        if (i.value.IdentId == this.vData.Equipment) {
          this.$refs.EuroFieldExtraPrice.fieldData = i.value.Price
          this.CalculateVat()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Achtung, Preis passt sich automatich an.',
              variant: 'warning',
            },
          })

        }
      })

    },
    ResetAddress(type) {
      if(type == "pickup") {
        this.vData.PickUpPassengerIdentId = 0;
        this.vData.PickUpPassengerNumber = "";
        this.vData.PickUpAddressContact = {
          Name: '',
              Phone: '',
              Phone2: '',
              Fax: '',
              Email: '',
              Web: '',
        }
        this.vData.PickUpAddress = {
          Street: '',
              ZipCode: '',
              Location: '',
              District: '',
        }

      } else {
        this.vData.DestinationPassengerIdentId = 0;
        this.vData.DestinationPassengerNumber = "";
        this.vData.DestinationAddressContact = {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: '',
        }
        this.vData.DestinationAddress = {
          Street: '',
          ZipCode: '',
          Location: '',
          District: '',
        }

      }
    },
    SaveAddress(type) {

      let da = {
        'addressIdentId': this.vData.PickUpPassengerIdentId,
        'addressId': this.vData.PickUpPassengerNumber,
        'address': this.vData.PickUpAddress,
        'contact': this.vData.PickUpAddressContact
      }

      if (type == 'destination') {
        da = {
          'addressIdentId': this.vData.DestinationPassengerIdentId,
          'addressId': this.vData.DestinationPassengerNumber,
          'address': this.vData.DestinationAddress,
          'contact': this.vData.DestinationAddressContact
        }
      }
      if (da.addressId == null || da.addressId == undefined || da.addressId == '') {
        if (da.address.Street.length > 0 && da.contact.Name.length > 0) {
          this.$http.post('/address/add', JSON.stringify(da))
              .then(resp => {
                if (resp.data.success) {
                  if (resp.data.infoText != '') {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Speichern',
                        icon: 'CheckIcon',
                        text: 'Adresse wurde aktualisiert. (' + resp.data.infoText + ').',
                        variant: 'warning',
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Speichern',
                        icon: 'CheckIcon',
                        text: 'Adresse wurde aktualisiert.',
                        variant: 'success',
                      },
                    })
                  }
                  console.log(resp.data)
                  if (type == 'destination') {
                    this.vData.DestinationPassengerNumber = resp.data.addressId
                  } else {
                    console.log(this.vData.PickUpPassengerNumber)
                    this.vData.PickUpPassengerNumber = resp.data.addressId
                    console.log(this.vData.PickUpPassengerNumber)
                  }
                }
              })
              .catch(err => {
                console.error(err)
              })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Abbruch',
              icon: 'CheckIcon',
              text: 'Es muss mindestens ein Name und eine Adresse eingegeben werden.',
              variant: 'warning',
            },
          })
        }
      } else {
        this.$swal({
          title: 'Ändern',
          text: 'Möchten sie diese Adresse wirklich ändern?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ja, ändern!',
          cancelButtonText: 'Nein, abbrechen',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
            .then(result => {
              console.log(result)
              if (result.isConfirmed) {
                this.$http.post('/address/save', JSON.stringify(da))
                    .then(resp => {
                      if (resp.data.success) {
                        if (resp.data.infoText != '') {
                          this.$toast({
                            component: ToastificationContent,
                            props: {
                              title: 'Speichern',
                              icon: 'CheckIcon',
                              text: 'Adresse wurde aktualisiert. (' + resp.data.infoText + ').',
                              variant: 'warning',
                            },
                          })
                        } else {
                          this.$toast({
                            component: ToastificationContent,
                            props: {
                              title: 'Speichern',
                              icon: 'CheckIcon',
                              text: 'Adresse wurde aktualisiert..',
                              variant: 'success',
                            },
                          })
                        }
                        if (type == 'destination') {
                          this.vData.DestinationPassengerNumber = resp.data.addressId
                        } else {
                          this.vData.PickUpPassengerNumber = resp.data.addressId
                        }
                      }
                    })
                    .catch(err => {
                      console.error(err)
                    })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Abbruch',
                    icon: 'CheckIcon',
                    text: 'Vorgang abgebrochen.',
                    variant: 'warning',
                  },
                })
              }
            })
      }
    },
    GetPickupNumberState() {
      return 'info'
    },
    GetDestinationNumberState() {
      return 'info'
    },
    RouterBack() {
      this.$router.back()
    },
    openInNewTab(url) {
      window.open(url, '_blank', 'noreferrer')
    },
    OpenDispo() {
      const date = this.vData.TravelDay.split('.')
      this.$router.push({
        name: 'Disposition',
        params: { day:  20+date[2]+"-"+date[1]+"-"+date[0] }
      })
    },

    OpenCreditNote(id) {
      let win = window.open('https://my.sevdesk.de/#/cn/detail/type/CN/id/' + id, '_blank')
      win.focus()
    },
    GetBlocked() {
      if (this.vData.Vid == 0) {
        return false
      }

      if (this.vData.BillNumber != '') {
        return true
      }

      if (this.vData.Canceled != null) {
        return true
      }

      return false
    },
    SelectInput(ref) {
      if (ref == 'LAST') {
        this.SaveCheck()
      } else if (ref == 'LASTINPUT') {
        this.$nextTick(() => this.$refs[ref].$el.select())
        setTimeout(() => {
          this.hasErrors = false
        }, 500)

      } else {
        if (ref == 'TransportTicket') {
          this.$nextTick(() => this.$refs.TransportTicket.$el.focus())
        } else if (ref == 'CustomerNumber') {
          this.$refs.CustomerNumber.$el.select()
        } else {
          this.$nextTick(() => this.$refs[ref].$el.select())
        }
      }
    },
    async CalculatePrice(setPrice = true) {
      let copyData = JSON.parse(JSON.stringify(this.vData))
      const date = copyData.TravelDay.split('.')

      copyData.TravelDay = new Date(parseInt(20 + date[2]), parseInt(date[1]), parseInt(date[0]), parseInt(copyData.PickupTime.split(':')[0]), parseInt(copyData.PickupTime.split(':')[1]), 0)

      await this.$http.post('/voucher/calculatePrice', JSON.stringify({
        'fromId': this.vData.PickUpPassengerIdentId,
        'toId': this.vData.DestinationPassengerIdentId,
        'from': {
          'street': this.vData.PickUpAddress.Street,
          'zipCode': this.vData.PickUpAddress.ZipCode,
          'location': this.vData.PickUpAddress.Location,
          'district': this.vData.PickUpAddress.District
        },
        'to': {
          'street': this.vData.DestinationAddress.Street,
          'zipCode': this.vData.DestinationAddress.ZipCode,
          'location': this.vData.DestinationAddress.Location,
          'district': this.vData.DestinationAddress.District
        },
        'travelDay': copyData.TravelDay

      }))
          .then(resp => {

            const passengers = parseInt(this.vData.Passengers) + parseInt(this.vData.PassengersChildren)
            let passengersPrice = parseFloat(resp.data.route.Enter1)
            if (passengers > 3) {
              passengersPrice = parseFloat(resp.data.route.Enter2)
            }
            if (this.vData.MedicalTrip != null) {
              if (!this.vData.MedicalTrip.TransportTicket) {
                if(setPrice)
                  this.$refs.EuroFieldPrice.fieldData = parseFloat(resp.data.route.Price) + passengersPrice
              }
            } else {
              if(setPrice)
                this.$refs.EuroFieldPrice.fieldData = parseFloat(resp.data.route.Price) + passengersPrice
              this.vData.Taxipreis = resp.data.route.Taxi
            }
            if(this.vData.RideType == 1) {
              this.$refs.MedicalTripPrice.fieldData = parseFloat(resp.data.route.MedicalPrice) + passengersPrice
            }

            this.CalculateVat()
            this.zoneName = 'Preis: ' + resp.data.route.Name

            this.vData.Taxipreis = parseFloat(resp.data.route.Taxi) + passengersPrice
            this.vData.MedicalPrice = parseFloat(resp.data.route.MedicalPrice)
            this.vData.MedicalTripPrice = parseFloat(resp.data.route.MedicalPrice)
            this.vData.TripRoute.TripDistanceMeter = resp.data.route.Distance
            this.vData.TripRoute.TripFullDistanceMeter = resp.data.route.TripFullDistanceMeter
            this.vData.TripRoute.TripDuration = resp.data.route.TripDuration
            this.vData.TripRoute.TripFullDuration = resp.data.route.TripFullDuration

            this.$refs.EuroFieldPrice.Blur()
            this.$refs.EuroFieldExtraPrice.Blur()
            this.$refs.MedicalTripPrice.Blur()
            this.filterTimeout = setTimeout(() => {
              this.$nextTick(() => this.NextInput('CustomerNumber'))
            }, 250)
          })
          .catch(err => {
            console.error(err)
          })
    },
    CalculateVat() {

      this.vData.Price = this.$refs.EuroFieldPrice.fieldData
      this.vData.PriceExtra = this.$refs.EuroFieldExtraPrice.fieldData
      const price = parseFloat(this.$refs.EuroFieldPrice.fieldData.toString()
          .replace(',', '.')) + parseFloat(this.$refs.EuroFieldExtraPrice.fieldData.toString()
          .replace(',', '.'))

      const identId = this.vData.Customer
      this.$http.post('/voucher/calculateVat', JSON.stringify({
        Price: price,
        CustomerIdentId: identId,
      }))
          .then(resp => {
            if (resp.data.Price > price) {
              this.VatRateLabel = `zzgl. (${resp.data.VarRate}%, ${this.$options.filters.currency(resp.data.VatPrice)})`
              this.EndSum = this.$options.filters.currency((resp.data.VatPrice + price))
            } else {

              this.VatRateLabel = `inkl. (${resp.data.VarRate}%, ${this.$options.filters.currency(resp.data.VatPrice)}`
              this.EndSum = this.$options.filters.currency((price))
            }
          })
          .catch(err => {
            console.error(err)
          })

      this.$refs.EuroFieldPrice.Blur()
      this.$refs.EuroFieldExtraPrice.Blur()
      this.$refs.MedicalTripPrice.Blur()

    },
    GetIataData(type) {
      if (type == 'Iata') {
        if (this.vData.Flight.Iata != '') {
          let split = this.vData.TravelDay.split('.')
          this.$http.get(`flightPlan/iata/${this.vData.Flight.Iata}/20${split[2]}-${split[1]}-${split[0]}`)
              .then(resp => {
                if (resp.data.success) {
                  this.vData.Flight.Arrivals = resp.data.flight.Arrivals
                  this.vData.Flight.Departure = resp.data.flight.Departure
                  this.vData.PickupTime = resp.data.flight.PickupTime
                  this.vData.Flight.ScheduledTime = resp.data.flight.ScheduledTime
                  this.NextInput('Iata', '')
                } else {
                  this.NextInput('Iata', 'Arrivals')
                  this.Audio('message-124468.mp3')
                  this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: `Flugnummer ist dem System nicht beaknnt.`,
                          variant: 'info',
                        },
                      },
                      {
                        timeout: 5000,
                      })
                }

              })
              .catch(err => {
                console.error(err)
              })
        }
      } else {
        if (this.returnTripData.Flight.Iata != '') {
          let splitR = this.returnTripData.TravelDay.split('.')
          this.$http.get(`flightPlan/iata/${this.returnTripData.Flight.Iata}/20${splitR[2]}-${splitR[1]}-${splitR[0]}`)
              .then(resp => {
                if (resp.data.success) {
                  this.returnTripData.Flight.Arrivals = resp.data.flight.Arrivals
                  this.returnTripData.Flight.Departure = resp.data.flight.Departure
                  this.returnTripData.PickupTime = resp.data.flight.PickupTime
                  this.returnTripData.Flight.ScheduledTime = resp.data.flight.ScheduledTime
                  this.NextInput('ReturnIata')
                } else {
                  this.NextInput('ReturnIata', 'ReturnArrivals')
                  this.Audio('message-124468.mp3')
                  this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: `Flugnummer ist dem System nicht beaknnt.`,
                          variant: 'info',
                        },
                      },
                      {
                        timeout: 5000,
                      })
                }

              })
              .catch(err => {
                console.error(err)
              })
        }
      }
    },
    HasUserDeleteRight() {
      this.R515 = this.$store.state.user.Rights.includes('R515')
    },
    GetPaymentName(id) {
      if (id == 0) {
        return 'Keine Zahlungsart'
      }
      if (id == 1) {
        return 'Rechnung'
      }
      if (id == 2) {
        return 'EC'
      }
      if (id == 3) {
        return 'Barzahlung'
      }
    },
    async LoadCustomer() {
      if (this.Customer.Number == '') {
        this.Customer.Number = 'BAR'
      }

      localStorage.lastVoucher_CustomerNumber = this.Customer.Number
      await this.$http.get(`/customer/customerNumber/${this.Customer.Number}`)
          .then(resp => {
            this.Customer.IdentId = resp.data.IdentId
            this.Customer.Name = resp.data.Name
            this.vData.Customer = resp.data.IdentId
            this.$refs.EuroFieldPrice.Focus()
            this.vData.PaymentMethod = resp.data.PaymentMethod

          })
          .catch(err => {
            console.error(err)
          })
      if (this.vData.Vid > 0) {
        await this.PriceCheck()
      } else {
        await this.GetPrice()
      }
    },
    SaveFlight(type) {

      this.$swal({
        title: 'Ändern',
        text: 'Möchten sie diesen Flug wirklich überschreiben?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, ändern!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.isConfirmed) {
              let date = this.vData.TravelDay.split('.')
              let fData = {
                Iata: this.vData.Flight.Iata,
                Day: new Date('20' + date[2] + '-' + date[1] + '-' + date[0]),
                Arrivals: this.vData.Flight.Arrivals,
                Departure: this.vData.Flight.Departure,
                Pickup: this.vData.PickupTime,
                ScheduledTime: this.vData.Flight.ScheduledTime,
              }
              console.log(fData)
              if (type == 2) {
                date = this.returnTripData.TravelDay.split('.')
                fData = {
                  Iata: this.returnTripData.Flight.Iata,
                  Day: new Date('20' + date[2] + '-' + date[1] + '-' + date[0]),
                  Arrivals: this.returnTripData.Flight.Arrivals,
                  Departure: this.returnTripData.Flight.Departure,
                  Pickup: this.returnTripData.PickupTime,
                  ScheduledTime: this.returnTripData.Flight.ScheduledTime,
                }
              }
              this.$http.post('/flightPlan/add/small/flight', JSON.stringify(fData))
                  .then(resp => {
                    if (resp.data.success) {
                      this.$toast({
                            component: ToastificationContent,
                            props: {
                              title: 'Info',
                              icon: 'CheckIcon',
                              text: `Flug wurde gespeichert.`,
                              variant: 'success',
                            },
                          },
                          {
                            timeout: 5000,
                          })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            }
          })
    },
    isValidDate: function (d) {
      const date = d.split('.')
      if (date.length != 3) {
        return false
      }
      const day = parseInt(date[0])
      if (day < 0 || day > 31) {
        return false
      }
      const month = parseInt(date[1])
      if (month < 0 || month > 12) {
        return false
      }
      const year = parseInt(date[2])
      if (year > 2021) {
        return false
      }

      return true
    },
    SaveCheck() {
      if ((parseInt(this.vData.Price) + parseInt(this.vData.PriceExtra)) > 300.00) {
        this.$swal({
          title: 'Preis Check',
          text: 'Der Fahrpreis ist über 300 Euro?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ja, Speichern!',
          cancelButtonText: 'Nein, abbrechen',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
            .then(result => {
              if (result.isConfirmed) {
                this.Save()
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Abbruch',
                    icon: 'CheckIcon',
                    text: 'Vorgang abgebrochen.',
                    variant: 'warning',
                  },
                })
              }
            })
      } else {
        this.Save()
      }
    },
    async CheckDate() {
      const date = this.vData.TravelDay.split('.');
      console.log(date);
      if (date[0].length === 2 && date[1].length === 2 && date[2].length === 2) {
        let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0]);
        const isNow = new Date();
        const zeitDifferenz = TravelDay - isNow;
        const tageDifferenz = Math.floor(zeitDifferenz / (1000 * 60 * 60 * 24));
        console.log(tageDifferenz)
        if (tageDifferenz < -1) {
          const result = await this.$swal({
            title: 'Reisetag',
            text: 'Reisetage ist in der Vergangenheit!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ja, Speichern!',
            cancelButtonText: 'Nein, abbrechen',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          });

          if (result.isConfirmed) {
            return true;
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Abbruch',
                icon: 'CheckIcon',
                text: 'Vorgang abgebrochen.',
                variant: 'warning',
              },
            });
            return false;
          }
        }
        if (tageDifferenz > 180) {
          const result = await this.$swal({
            title: 'Reisetag',
            text: 'Reisetage ist in über 180 Tagen?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ja, Speichern!',
            cancelButtonText: 'Nein, abbrechen',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          });

          if (result.isConfirmed) {
            console.log("TRUE");
            return true;
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Abbruch',
                icon: 'CheckIcon',
                text: 'Vorgang abgebrochen.',
                variant: 'warning',
              },
            });
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    async Save() {
      let checkDate = await this.CheckDate();
      if(!checkDate) {
        return
      }

      if (this.loading.base == false) {

        if (this.vData && this.vData.Price) {
          const str = String(this.vData.Price)

                    if (str.includes(',')) {
            const newStr = str.replace(',', '.')
            const regex = /([0-9]+,[0-9]+)/g

            // Erhaltung des numerischen Wertes
            const value = this.vData.Price.match(regex)
            if (value) {
              // Ersetzen des Kommas durch einen Punkt
              this.vData.Price = value[0].replace(',', '.')
            }
          } else {
            console.log(str)
            console.log(', object or Price property is missing')
          }
        } else {
          console.log('copyData object or Price property is missing')
        }
        this.CalculateVat()
        this.loading.base = true
        delete this.vData.Id

        if(this.vData.RideType == 1)
          this.vData.MedicalTrip.GrossSum = this.$refs.MedicalTripPrice.fieldData

        let copyData = JSON.parse(JSON.stringify(this.vData))

        if (!this.isValidDate(copyData.TravelDay)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Datum ist ungültig.',
              variant: 'danger',
            },
          })
          this.loading.base = false
          return
        }
        if (!(copyData.Passengers > 0)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Personenanzahl ist ungültig.',
              variant: 'danger',
            },
          })
          this.loading.base = false
          return
        }
        if (!(copyData.Customer > 0)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Rechnungskunde ist ungültig.',
              variant: 'danger',
            },
          })
          this.loading.base = false
          return
        }
        if (this.vData.PickupTime.length != 5) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Info',
              icon: 'CheckIcon',
              text: 'Pickupzeit ist ungültig (' + this.vData.PickupTime + ' (' + this.vData.PickupTime.length + ')).',
              variant: 'danger',
            },
          })
          this.loading.base = false
          return
        }
        localStorage.lastVoucher = JSON.stringify(this.vData)
        const date = copyData.TravelDay.split('.')
        copyData.TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
        let copyDataReturn = null
        if (this.returnTripData.Passengers > 0) {
          if (this.returnTripData.PickupTime.length != 5) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Info',
                icon: 'CheckIcon',
                text: 'Pickupzeit ist ungültig.(' + this.returnTripData.PickupTime + ' (' + this.returnTripData.PickupTime.length + '))',
                variant: 'danger',
              },
            })
            this.loading.base = false
            return
          }
          copyDataReturn = JSON.parse(JSON.stringify(this.vData))
          const returnDate = this.returnTripData.TravelDay.split('.')
          copyDataReturn.TravelDay = new Date('20' + returnDate[2] + '-' + returnDate[1] + '-' + returnDate[0])

          let PickUpAddress = this.vData.PickUpAddress
          let PickUpAddressContact = this.vData.PickUpAddressContact
          let PickUpPassengerIdentId = this.vData.PickUpPassengerIdentId
          let PickUpPassengerNumber = this.vData.PickUpPassengerNumber
          let DestinationAddress = this.vData.DestinationAddress
          let DestinationAddressContact = this.vData.DestinationAddressContact
          let DestinationPassengerIdentId = this.vData.DestinationPassengerIdentId
          let DestinationPassengerNumber = this.vData.DestinationPassengerNumber

          copyDataReturn.PickUpAddress = DestinationAddress
          copyDataReturn.PickUpAddressContact = DestinationAddressContact
          copyDataReturn.PickUpPassengerIdentId = DestinationPassengerIdentId
          copyDataReturn.PickUpPassengerNumber = DestinationPassengerNumber

          copyDataReturn.DestinationAddress = PickUpAddress
          copyDataReturn.DestinationAddressContact = PickUpAddressContact
          copyDataReturn.DestinationPassengerIdentId = PickUpPassengerIdentId
          copyDataReturn.DestinationPassengerNumber = PickUpPassengerNumber

          copyDataReturn.Passengers = this.returnTripData.Passengers
          copyDataReturn.PassengersChildren = this.returnTripData.PassengersChildren
          copyDataReturn.MedicalTrip = this.returnTripData.MedicalTrip
          copyDataReturn.Flight = this.returnTripData.Flight
          copyDataReturn.PickupTime = this.returnTripData.PickupTime
          copyDataReturn.Description1 = this.returnTripData.Description1
          copyDataReturn.Description2 = this.returnTripData.Description2
          copyDataReturn.DescriptionPdf = this.returnTripData.DescriptionPdf

        }

        this.$http.post('/voucher/set', JSON.stringify(copyData))
            .then(resp => {
              if (resp.data.success) {
                if (copyDataReturn != null) {
                  copyDataReturn.ConnectedVoucherId = resp.data.newVid
                  this.$http.post('/voucher/set', JSON.stringify(copyDataReturn))
                      .then(resp => {
                        if (resp.data.success) {
                          this.$toast({
                                component: ToastificationContent,
                                props: {
                                  title: 'Info',
                                  icon: 'CheckIcon',
                                  text: `Voucher (${resp.data.newVid} und ${copyDataReturn.ConnectedVoucherId}) wurde gespeichert.`,
                                  variant: 'success',
                                },
                              },
                              {
                                timeout: 10000,
                              })
                          this.loading.base = false
                          this.$router.back()
                        }
                      })
                      .catch(err => {
                        this.loading.base = false
                        console.error(err)
                      })
                } else {
                  this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: `Voucher (${resp.data.newVid}) wurde gespeichert.`,
                          variant: 'success',
                        },
                      },
                      {
                        timeout: 10000,
                      })
                  this.loading.base = false
                  this.$router.back()
                }
              }
            })
            .catch(err => {
              this.loading.base = false
              console.error(err)
            })
      }
    },
    UpdateMarker() {
      this.VehicleMarkers.forEach((aData, index) => {
        let found = false
        this.Maps.Pickup.markers.forEach((mData, index2) => {
          if (mData.id == aData.id) {
            this.Maps.Pickup.markers[index2].position = aData.position
            found = true
          }
        })

        if (!found) {
          this.Maps.Pickup.markers.push(aData)
        }
      })

    },

    UpdateVehicleMarker() {
      this.$http.get(`/vehicle/positions`)
          .then(resp => {
            this.VehicleMarkers = []
            resp.data.forEach(i => {
              const marker = {
                lat: i.Coordinates.lat,
                lng: i.Coordinates.lng,
              }
              this.VehicleMarkers.push({
                id: 'v' + i.Vid,
                position: marker,
                icon: {
                  url: `data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><text x="18" y="20" font-size="20" text-anchor="middle"  fill="blue">${i.PlateShort}</text></svg>`,
                  scaledSize: {
                    width: 36,
                    height: 36
                  },
                }
              })

            })
            this.UpdateMarker()
          })
          .catch(err => {
            console.error(err)
          })
    },
    async LoadVoucher() {
      this.FormatTravelDay()
      if (this.$route.params.id > 0) {
        await this.$http.get(`/voucher/get2/${this.$route.params.id}`)
            .then(resp => {
              if (resp.data.success == true) {
                this.Drivers = resp.data.drivers
                let d = new Date(resp.data.voucher.TravelDay)
                let ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(d)
                let mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
                let da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
                resp.data.voucher.TravelDay = da + '.' + mo + '.' + ye

                if (resp.data.voucher.DestinationAddress.Coordinates != null) {
                  const marker = {
                    lat: resp.data.voucher.DestinationAddress.Coordinates.lat,
                    lng: resp.data.voucher.DestinationAddress.Coordinates.lng,
                  }
                  this.Maps.Pickup.markers.push({ position: marker })
                }
                if (resp.data.voucher.PickUpAddress.Coordinates != null) {
                  const marker = {
                    lat: resp.data.voucher.PickUpAddress.Coordinates.lat,
                    lng: resp.data.voucher.PickUpAddress.Coordinates.lng,
                  }
                  this.Maps.Pickup.markers.push({ position: marker })
                }
                this.UpdateMarker()
                if (resp.data.voucher.Flight == null) {
                  resp.data.voucher.Flight = {
                    Iata: '',
                    Departure: '',
                    Arrivals: '',
                    ScheduledTime: '00:00',
                    ExpectedTime: '00:00'
                  }
                }
                if (resp.data.voucher.MedicalTrip == null) {
                  resp.data.voucher.MedicalTrip = {
                    TransportTicket: null,
                    AdditionalPayment: null,
                    AppointmentTime: '',
                  }
                }

                this.vData = resp.data.voucher

                this.GetConnectedVoucherData(this.vData.Vid)

                this.$refs.EuroFieldPrice.fieldData = this.vData.Price
                this.$refs.EuroFieldExtraPrice.fieldData = this.vData.PriceExtra
                if(this.vData.RideType == 1 && this.vData.MedicalTrip.GrossSum != null)  {
                  this.$refs.MedicalTripPrice.fieldData = this.vData.MedicalTrip.GrossSum
                  this.$refs.MedicalTripPrice.Blur()

                }
                this.$refs.EuroFieldPrice.Blur()
                this.$refs.EuroFieldExtraPrice.Blur()
              } else {
                this.RouterBack()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Fehler',
                    icon: 'CheckIcon',
                    text: resp.data.voucher.message,
                    variant: 'danger',
                  },
                })
              }

            })
            .catch(err => {
              console.error(err)
            })

        if (!this.vData.Customer) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'warning',
              icon: 'CheckIcon',
              text: 'Voucher hat keinen Rechnungskunde.',
              variant: 'warning',
            },
          })
          this.vData.Customer = 0
        } else {
          await this.$http.get(`/customer/customerId/${this.vData.Customer}`)
              .then(resp => {
                console.log(resp)
                console.log(this.vData.Customer)
                this.Customer.Name = resp.data.Name
                this.Customer.Number = resp.data.CustomerNumber
                this.Customer.IdentId = this.vData.Customer
              })
              .catch(err => {
                console.error(err)
              })
        }
        await this.CalculateVat()
        this.FormatTravelDay()
        this.ChangeRideType(this.vData.RideType)
      }
      if (this.$route.params.id == 0) {

        await this.$http.get(`/voucher/get/tempVoucherId`)
            .then(resp => {
              if (resp.data.success) {
                this.tempId = resp.data.vId
              }
            })
            .catch(err => {
              console.error(err)
            })
        if (!this.$route.params.type) {
          this.ChangeRideType(0)
        } else {
          this.ChangeRideType(this.$route.params.type)
        }
      }
    }
  }
}
</script>

<style scoped>
.popover {
  max-width: 100%; /* Max Width of the popover (depending on the container!) */
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>

<style lang="scss">
.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>
